export default {
  guid: "437c4aa5-0410-47e4-b976-27dbfeda165b",
  title: "Escrime XXI - Issue 113",
  shortTitle: "",
  description: "",
  width: 1532,
  height: 1149,
  currentLanguage: "EN",
  languages: [
    {
      code: "EN",
      text: "English",
      href: "http://escrime-xxi.fie.org/113/en"
    },
    {
      code: "FR",
      text: "French",
      href: "http://escrime-xxi.fie.org/113/fr"
    },
    {
      code: "ES",
      text: "German",
      href: "http://escrime-xxi.fie.org/113/es"
    }
  ],
  basePath: "/113/en",
  // basePath: "",
  companyLogo: "1-numeral.jpg",
  publishURL: "http://escrime-xxi.fie.org/113/en/static/_thumbs/",
  externalResources: [
    "https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"
  ],
  options: {
    doublePage: false,
    rightToLeft: false,
    searchEnabled: true,
    downloadEnabled: false,
    downloadPath: "",
    printEnabled: false,
    zoomEnabled: true,
    contentsEnabled: true,
    languagesEnabled: false,
    mobileSwitch: true,
    guideEnabled: false,
    galleryCaptions: {}
  },
  pages: [
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 0,
        subIndex: 0,
        startIndex: 0,
        original: "pg1.jpg",
        zoom: null,
        content: `
        <img id="1-0" class="halfScale" style="top:0px;left:371px" src="/113/en/static/_content/1-numeral.png">
        
        <img id="1-1" class="halfScale" style="top:110px;left:0px" src="/113/en/static/_content/1-title.png">
        <img id="1-2" class="halfScale" style="top:275px;left:68px" src="/113/en/static/_content/1-sub-1.png">

        <img id="1-3" class="halfScale" style="top:111px;left:1075px" src="/113/en/static/_content/1-issue.png">

        <img id="1-text-1" class="halfScaleR pointer" style="top:389px;right:0px" onclick="Publish.goToPage(40)" src="/113/en/static/_content/1-sub-2.png">
        <img id="1-text-2" class="halfScaleR pointer" style="top:542px;right:0px" onclick="Publish.goToPage(45)" src="/113/en/static/_content/1-sub-3.png">
        <img id="1-text-3" class="halfScaleR pointer" style="top:657px;right:0px" onclick="Publish.goToPage(54)" src="/113/en/static/_content/1-sub-4.png">

        <img id="1-4" class="halfScale pointer" style="top:988px;left:1442px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/1-arrow.png">

        `,
        script: `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim
          .fromTo(idOf("1-1"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)
          .fromTo(idOf("1-0"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},"-=0.2")
          .fromTo(idOf("1-2"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},"-=0.2")
          .fromTo(idOf("1-3"), 0.5, {y: 30, opacity:0}, {y: 0, opacity:1},"-=0.2")
          .fromTo(idOf("1-text-1"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-text-2"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-text-3"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-4"), 0.5, {x:-60, opacity:0}, {x:0, opacity:1})
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
        searchText: "",
        mobileHtml: `
        <img src="/113/en/static/_mobile/pg1.jpg">
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 1,
        subIndex: 0,
        startIndex: 0,
        original: "pg2.jpg",
        zoom: null,
        content: `

      <img class="halfScale 2-title" style="top:82px;left:84px" src="/113/en/static/_content/2-title.png">

      <img class="halfScale 2-icons" style="top:864px;left:169px" src="/113/en/static/_content/2-pop.png">
      <img class="halfScale 2-icons" style="top:865px;left:448px" src="/113/en/static/_content/2-play.png">
      <img class="halfScale 2-icons" style="top:865px;left:809px" src="/113/en/static/_content/2-soc.png">
      <img class="halfScale 2-icons" style="top:865px;left:1136px" src="/113/en/static/_content/2-no.png">

      <img class="halfScale pointer howto-desktop" style="top:125px;left:910px;opacity:1;" onclick="switchPopHowto(true)" src="/113/en/static/_content/2-desktop-btn.png">
      <img class="halfScale pointer howto-ipad" style="top:125px;left:1112px;opacity:0" onclick="switchPopHowto(false)" src="/113/en/static/_content/2-ipad-btn.png">

      <img class="halfScale howto-desktop" style="top:257px;left:85px;" src="/113/en/static/_content/2-desktop.png">
      <img class="halfScale howto-ipad" style="top:250px;left:71px;display:none;" src="/113/en/static/_content/2-ipad.png">

      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
        script: `
        function onPageEnter() {
          pg2Anim = new TimelineMax()
          pg2Anim.fromTo(cOf("2-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .staggerFromTo(cOf("2-icons"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, onComplete: addContentLinks}, 0.3, "-=0.2")
        }

        function switchPopHowto(bool){
          if(bool){
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-ipad")[0].style.opacity = 0;
              cOf("howto-ipad")[1].style.display = "none";
            }});
            cOf("howto-desktop")[0].style.opacity = 1;
            cOf("howto-desktop")[1].style.display = "block";
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
          }else{
            cOf("howto-ipad")[0].style.opacity = 1;
            cOf("howto-ipad")[1].style.display = "block";
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-desktop")[0].style.opacity = 0;
              cOf("howto-desktop")[1].style.display = "none";
            }});
          }
        }

        function onPageLeave() {
          pg2Anim.stop()
          removeContentLinks()
        }
      `,
        searchText:
          "HOW TO USE  Click to change view  HOW TO USE  DESKTOP  Escrime XXI The Fencing Magazine uses the latest digital technology - here are some of the exciting features to enjoy.  IPAD  BROWSING Use the arrows on your keypad to navigate horizontally through the magazine  Navigation To view the magazine, use the arrows on your keypad to travel left and right through the publication.  BROWSER For the best results, we recommend using Safari or Google Chrome  EXPLORE  ide... Hotspots ins  1 2 3 POP UPS  PLAY BUTTON  SOCIAL MEDIA  NUMBERS  Press to reveal, and hide, nuggets of information.  This magazine features great video. Pushing this will launch one.  Press the social media icons found throughout the magazine  Push the buttons to reveal more exciting content.  W W W.FIE .ORG"
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 2,
        subIndex: 0,
        startIndex: 0,
        original: "pg3.jpg",
        zoom: null,
        content: `
          <a href="http://www.tissotwatches.com" target="_blank">
            <div class="contentLinkNone" style="bottom:24px;right:40px;width:280px; height:30px;"></div>
          </a>`,
        script: `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
        searchText: "",
        mobileHtml: `
      
      <a href="http://www.tissotwatches.com" target="_blank">
        <img src="/113/en/static/_mobile/pg3.jpg">
      </a>

      `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 3,
        subIndex: 0,
        startIndex: 0,
        original: "pg4.jpg",
        zoom: null,
        content: `

        <a href="http://www.fie.org" target="_blank">
            <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <div class="addContentLink" style="top: 191px; left:80px;width:145px; height: 35px;">
          <a href="http://www.fie.org" target="_blank"></a></div>

        <div class="addContentLink" style="top: 82px; right:627px;width:44px; height: 43px;">
          <a href="https://www.facebook.com/fie.org" target="_blank"></a></div>

        <div class="addContentLink" style="top:131px; right:626px;width:45px; height: 43px;">
          <a href="https://twitter.com/FIE_fencing" target="_blank"></a></div>

        <img id="4-title" class="halfScale" style="top:81px;left:80px" src="/113/en/static/_content/4-title.png">

        <img id="fourIpad" class="cont-item-0-link halfScale" style="top:386px;left:591px" src="/113/en/static/_content/4-ipad.png">
        <img class="cont-item cont-item-1-btn halfScale" style="top:327.7px;left:574px;opacity:0" src="/113/en/static/_content/4-editorial.png">
        <img class="cont-item cont-item-2-btn halfScale" style="top:267px;left:574px;opacity:0" src="/113/en/static/_content/4-sport.png">
        <img class="cont-item cont-item-3-btn halfScale" style="top:267px;left:574px;opacity:0" src="/113/en/static/_content/4-congress.png">
        <img class="cont-item cont-item-4-btn halfScale" style="top:266.5px;left:574px;opacity:0" src="/113/en/static/_content/4-interview.png">
        <img class="cont-item cont-item-5-btn halfScale" style="top:352px;left:574px;opacity:0" src="/113/en/static/_content/4-federations.png">
        <img class="cont-item cont-item-6-btn halfScale" style="top:328px;left:574px;opacity:0" src="/113/en/static/_content/4-eurosport.png">
        <img class="cont-item cont-item-7-btn halfScale" style="top:328px;left:574px;opacity:0" src="/113/en/static/_content/4-obituaries.png">

        <img id="4-next" class="halfScale pointer" style="top:940px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/4-arrow.png">

        <div class="addContentLink" onclick="contentsBub(1);" style="top:358px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(2);" style="top:450px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(3);" style="top:543px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(4);" style="top:635px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(5);" style="top:727px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(6);" style="top:819px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(7);" style="top:911px; left:84px; width: 492px; height: 60px;"></div>

        <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)" style="top:357px;left:576px;width:638px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)" style="top:266px;left:650px;width:700px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(11)" style="top:357px;left:650px;width:701px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(15)" style="top:449px;left:650px;width:701px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(17)" style="top:541px;left:650px;width:701px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(21)" style="top:634px;left:650px;width:701px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(24)" style="top:724px;left:650px;width:701px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(28)" style="top:816px;left:650px;width:701px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(33)" style="top:908px;left:650px;width:701px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(35)" style="top:1000px;left:650px;width:701px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(40)" style="top:541px;left:574px;width:597px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(45)" style="top:633px;left:576px;width:595px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(48)" style="top:450px;left:650px;width:685px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(50)" style="top:542px;left:650px;width:685px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(54)" style="top:632px;left:650px;width:685px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(58)" style="top:724px;left:576px;width:755px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(62)" style="top:817px;left:576px;width:776px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(63)" style="top:910px;left:576px;width:776px;height:64px;display:none;"></div>
      `,
        script: `
      function onPageEnter() {
        pg4Anim = new TimelineMax();
        
        pg4Anim.fromTo(idOf("4-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)
        .fromTo(idOf("4-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
  
  
      function contentsBub(index){
       
        console.log("contentsBub", index)
        for(var i=0; i <= 7; i++){
          if(i == index){
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
              console.log(c)
              c.style.display = "";
            },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:1, onComplete:function(){
              
              classc("cont-item-"+index+"-link")[0].style.display = ""
              if(classc("cont-item-"+index+"-link")[1]){
                classc("cont-item-"+index+"-link")[1].style.display = "" 
              }
            }});
          }else{
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                c.style.display = "none";
              },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:0});

          }
        }
      }
  
      function onPageLeave() {
        pg4Anim.stop()
        removeContentLinks();
        contentsBub(0);
        TweenMax.to(idOf('fourIpad'), 0.1, {opacity:1});
      }
      `,
        searchText:
          "THIS ISSUE  Welcome to the latest edition of Escrime XXI, packed with the best fencing images, video and features and showcased in a striking new look.  WWW.FIE.ORG  EDITORIAL  SPORT  Tap buttons to reveal content  CONGRESS  INTERVIEW  FIE & NATIONAL FEDERATIONS NEWS  EUROSPORT VLOG  W W W.FIE .ORG"
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 4,
        subIndex: 0,
        startIndex: 0,
        original: "pg5.jpg",
        zoom: null,
        content: `
        <img class="halfScale pointer 5-arrow" style="top:854px;left:1386px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/5-arrow.png">

        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1012px;left:54px" src="/113/en/static/_content/white-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1012px;left:123px" src="/113/en/static/_content/white-facebook.png">
        </a>
        <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1012px;left:193px" src="/113/en/static/_content/white-yt.png">
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        
        <a href="mailto:info@fie.ch">
          <div class="contentLinkNone" style="bottom:241px;right:692px;width:154px; height:25px;"></div>
        </a>
        <a href="http://www.touchline.com" target="_blank">
          <div class="contentLinkNone" style="bottom:178px;right:307px;width:309px; height:30px;"></div>
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:212px;right:746px;width:98px; height:25px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg5Anim = new TimelineMax()
          pg5Anim
            .fromTo(cOf("5-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg5Anim.stop()
        }
      `,
        searchText:
          "LIST OF C OME X  President: Alisher Usmanov (RUS) Secretary General: Emmanuel Katsiadakis (M.H.) (GRE) Secretary Treasurer: Ferial Nadira Salhi (ALG)  FIE HEAD OFFICE  Vice Presidents: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Members: Erika Aze (LAT) Jacek Bierkowski (POL) Ana Irene Delgado Guerra (PAN) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX) Aldo Montano President of the FIE athletes’ commission (ITA)  Administration  President, African Fencing Confederation: Mbagnick Ndiaye (SEN) President, Pan-American Fencing Confederation: Vitaly Logvin (MEX) President, Asian Fencing Confederation: Celso L. Dayrit (M.H.) (PHI) President, European Fencing Confederation: Stanislav Pozdnyakov (RUS) President, Oceanian Fencing Confederation: Helen Smith (M.H.) (AUS)  Nina Lalovic (SRB)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Chief Executive Officer Nathalie Rodriguez M.-H. (FRA)  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Administration Director: Elena Murdaca (ITA) Accounting Manager: Sandra Baroni (SUI) Assistant to the Director: Gabrielle Meylan (BRA) Administrative Assistant: Ylenia Murdaca (ITA) Head of Operations: Elena Huot (RUS) Sport  Sport and Technical Director: Evgeny Tsoukhlo (RUS)  Sport Technology and Administration Manager: Natalia Bodrova (RUS)  Sport Operation Manager: Sophie Treyvaud (SUI) Communication, Marketing, TV  Head of FIE President’s Cabinet: Digital Communications Manager: Maria Ntanou (GRE)  Head of FIE TV Production: Barna Heder (HUN)  FIE TV Production Assistant: Svetlana Krasnokoutskaya (RUS) Press Officer: Serge Timacheff (USA) Photographer: Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG",
        mobileHtml: `
      <p>
      <b>President</b>:<br> Alisher Usmanov (RUS)<br>
      <b>Secretary General</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>
      <b>Secretary Treasurer</b>:<br> Ferial Nadira Salhi (ALG)</p>
      <p>
      <b>Vice Presidents</b>:<br>
      Ana Pascu (M.H.) (ROU)<br>
      Donald Anthony (USA)<br>
      Yuki Ota (JPN)<br></p>
      <p>
      <b>Members</b>:<br>
      Erika Aze (LAT)<br>
      Jacek Bierkowski (POL)<br>
      Velichka Hristeva (BUL)<br>
      Isabelle Lamour (FRA)<br>
      Novak Perovic (RSA)<br>
      Oleg Peskov (KAZ)<br>
      Giorgio Scarso (ITA)<br>
      Bence Szabo (HUN)<br>
      Pascal Tesch (LUX)<br>
      Wei WANG (CHN)<br>
      Aldo Montano President of the FIE athletes commission (ITA)<br></p>

      <p>
        <b>President, African Fencing Confederation</b>: <br>Mbagnick Ndiaye (SEN) <br>
        <b>President, Pan-American Fencing Confederation</b>: <br>Vitaly Logvin (MEX) <br>
        <b>President, Asian Fencing Confederation</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>
        <b>President, European Fencing Confederation</b>: <br>Stanislav Pozdnyakov (RUS)<br>
        <b>President, Oceanian Fencing Confederation</b>: <br>Helen Smith (M.H.) (AUS)<br>
      </p>
      
      <h2>FIE Head Office</h2>
      <p>
      <b>Chief Executive Officer</b><br>
      Nathalie Rodriguez M.-H. (FRA)
      </p>

      <h2>Administration</h2>
      <p>
      <b>Administration Director</b>:<br> Elena Murdaca (ITA)<br>
      <b>Accounting Manager</b>:<br> Sandra Baroni (BUL) <br>
      <b>Assistant to the Director</b>:<br> Gabrielle Meylan (BRA)<br>
      <b>Administrative Assistant</b>:<br> Ylenia Murdaca (ITA)<br>
      <b>Head of Operations</b>:<br> Elena Huot (RUS)<br>
      </p>

      <h2>Sport</h2>
      <p>
      <b>Sport and Technical Director</b>:<br> Evgeny Tsoukhlo (RUS)<br>
      <b>Sport Technology and Administration Manager</b>:<br> Natalia Bodrova (RUS)<br>
      <b>Sport Operation Manager</b>:<br>Sophie Treyvaud (SUI) <br>
      </p>
      <h2>Communication, Marketing, TV</h2>
      <p>
      <b>Head of FIE President's Cabinet</b>:<br> Nina Lalovic (SRB)<br>
      <b>Digital Communications Manager</b>:<br> Maria Ntanou (GRE)<br>
      <b>Head of FIE TV Production</b>:<br> Barna Heder (HUN) <br>
      <b>FIE TV Production Assistant</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>
      <b>Press Officer</b>:<br> Serge Timacheff (USA)<br>
      <b>Photographer</b>:<br> Augusto Bizzi (ITA)<br>
      </p>

      <h2>Design</h2>
      <p>
      Touchline </b><br>
      (<a href="http://www.touchline.com" target="blank">www.touchline.com</a>)
      </p>
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 5,
        subIndex: 0,
        startIndex: 0,
        original: "pg6.jpg",
        zoom: null,
        content: `
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>

        <img id="6-img" class="halfScale 6-text-1 6-text" style="top:343px;left:480px" src="/113/en/static/_content/6-img.png">
        <img id="6-title" class="halfScale 6-text-1 6-text" style="top:720px;left:159px" src="/113/en/static/_content/6-title.png">

        <img id="6-text-1" class="halfScale 6-text-1 6-text" style="top:341px;left:784px" src="/113/en/static/_content/6-text-1.png">
        <img id="6-text-2" class="halfScale 6-text-2 6-text" style="top:338px;left:201px; opacity:0;" src="/113/en/static/_content/6-text-2.png">
        <img id="6-text-3" class="halfScale 6-text-3 6-text" style="top:338px;left:201px; opacity:0;" src="/113/en/static/_content/6-text-3.png">

        <img id="6-cta-1" class="halfScale pointer 6-btn" style="top:819px;left:783px" onclick="toggleText6('6-text-1', '6-cta-1');" src="/113/en/static/_content/6-cta-1.png">
        <img id="6-cta-2" class="halfScale pointer 6-btn" style="top:819px;left:965px;opacity:0" onclick="toggleText6('6-text-2', '6-cta-2');" src="/113/en/static/_content/6-cta-2.png">
        <img id="6-cta-3" class="halfScale pointer 6-btn" style="top:819px;left:1150px;opacity:0" onclick="toggleText6('6-text-3', '6-cta-3');" src="/113/en/static/_content/6-cta-3.png">

        <img id="6-next" class="halfScale pointer" style="top:938px;left:1387px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/6-arrow.png">
      `,
        script: `
      function onPageEnter(){
        pg6Anim = new TimelineMax();
        pg6Anim.fromTo(idOf("6-img"), 0.5,{opacity:0}, {opacity:1},0.5)
            .fromTo(idOf("6-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},"-=0.2")
            .fromTo(idOf("6-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},"+=0.3")
      }

      function toggleText6(text, btn){
        console.log(idOf(btn))
        console.log(cOf(text))
        TweenMax.to(cOf("6-btn"), 0.1, {opacity:0});
        TweenMax.to(idOf(btn), 0.1, {opacity:1});
        TweenMax.to(cOf("6-text"), 0.1, {opacity:0});
        TweenMax.to(cOf(text), 0.1, {opacity:1});
      }

      function onPageLeave(){
        toggleText6('6-text-1', '6-cta-1');
        pg6Anim.stop();
        removeContentLinks()
      }
      `,
        searchText:
          "FORE WORD  Dear Fencing Family, The 2020 season is moving forward on the Road to Tokyo where, for the first time in history, 12 senior fencing events will take place at next Summer Olympic Games. Federations, fencers and teams are working hard to make it a excellent year with an exciting series of important fencing activities.  THE CURTAIN RISES ON OLYMPIC SEASON  Our competition season started in September with a series of satellite events followed up by our World Cup events. This month the first of our nine Grand Prix events will take place in  PAGE 1  PAGE 2  PAGE 3  W W W.FIE .ORG",
        mobileHtml: `
          <h2>The curtain rises on Olympic season</h2>
          <img src="/113/en/static/_mobile/6-img.jpg">
          <p><b>Dear Fencing Family,</b></p>
          <p>The 2020 season is moving forward on the Road to Tokyo where, for the first time in history, 12 senior fencing events will take place at next Summer Olympic Games. Federations, fencers and teams are working hard to make it a excellent year with an exciting series of important fencing activities.</p>
          <p>Our competition season started in September with a series of satellite events followed up by our World Cup events. This month the first of our nine Grand Prix events will take place in Montreal, Doha and Turin, highlighting the importance of the Olympic qualification period which runs until April. </p>
          <p>Meanwhile in Tokyo work continues in Tokyo in preparation for the Olympic Games. In December, we worked with our Tokyo organising team to hold the official Olympic Test Event for fencing, which took place in the Makuhari Messe venue featuring the Prince Takamado Trophy Men’s Foil World Cup. </p>
          <p>At our Annual Congress in Lausanne in November, we were honoured to welcome IOC President Thomas Bach whom the Congress awarded the 2019 Chevalier Feyerick Challenge trophy. We officially approved four new nations as FIE members, bringing our total to 157. The organisation of the 2021 Senior World Championships was granted to Egypt, several countries are now official candidates in the bidding process for 2022 Junior and Cadet (United Arab Emirates), Senior (Hong Kong, Japan and Korea) and Veteran (Bulgaria) World Championships. </p>
          <p>Numerous decisions were made at the Congress, including giving World or Olympic champions the right to have their names and countries printed on their jackets in red or gold, respectively. It was also decided that beginning with the 2020-2024 quadrennium, all FIE commissions must have a minimum of 30 percent women representation. The 2019 Fair Play trophy was given awarded to the Hungarian men’s sabre team and Bolade Apithy (FRA). Top-ranked junior and senior individuals and teams in each weapon were awarded medals, along with a Nations Grand Prix given to Russia for seniors and Italy for juniors. The closing gala dinner was held at the renowned Olympic Museum in Lausanne, attended by Mr.Bach and other guests along with the members of the International Fencing Family.</p>
          <p>As the excitement builds for this very important season, the FIE continues to grow fencing worldwide through a wide range of development and educational programs as well as broadened event coverage on social media and broadcast television. We expect that fencing will be presented to more people in 2020 than any year in history. Thank you for being part of the world fencing family and sharing your skills and talents. Each of us can make a difference in achieving success. I wish you all a prosperous and successful New Year and that I am sure that you may achieve your fencing dreams. </p>
          <br>
          <p>Alisher Usmanov</p>
          <p><strong>FIE President</strong></p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 6,
        subIndex: 0,
        startIndex: 0,
        original: "pg7.jpg",
        zoom: null,
        content: `
        
        <a href="http://www.absolutefencinggear.com" target="_blank">
          <div class="contentLink" style="top:962px;left:769px;width:719px; height:54px;"></div>
        </a>
        
        `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
      
      <a href="http://www.absolutefencinggear.com" target="_blank">
        <img src="/113/en/static/_mobile/pg7.jpg">
      </a>
      `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 7,
        subIndex: 0,
        startIndex: 0,
        original: "pg8.jpg",
        zoom: null,
        content: `
      <img class="halfScale 8-title" style="top:110px;left:668px" src="/113/en/static/_content/8-title.png">

      <img class="halfScale 8-line" style="top:290px;left:668px" src="/113/en/static/_content/8-line.png">

      <img class="halfScale 8-sub" style="top:290px;left:711px" src="/113/en/static/_content/8-sub.png">

      <img class="halfScale pointer 8-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/arrow.png">
      `,
        script: `
        function onPageEnter() {
          pg8Anim = new TimelineMax()
          pg8Anim.fromTo(cOf("8-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("8-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("8-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("8-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg8Anim.stop()
        }
      `,
        searchText:
          "WORLD CUP  TALLINN WOMEN’S EPEE WORLD CUP TALLINN, ESTONIA NOVEMBER 1-3, 2019",
        mobileHtml: `
        <h2>Tallinn women's epee World Cup</h2>
        <img src="/113/en/static/_mobile/pg8.jpg">
        <p><b>Tallinn, Estonia<br>
        November 1-3, 2019<br></b></p>
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 8,
        subIndex: 0,
        startIndex: 0,
        original: "pg9.jpg",
        zoom: null,
        content: `
      <img class="halfScale pointer 9-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/9-arrow.png"> 

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
      </a>
      `,
        script: `
        function onPageEnter() {
          pg9Anim = new TimelineMax()
          pg9Anim
            .fromTo(cOf("9-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg9Anim.stop()
        }
      `,
        searchText:
          "TALLINN WOMEN'S EPEE WORLD CUP TALLINN, ESTONIA 2 OF 3  In the first FIE senior world cup of the 2019-2020 international fencing competition season, Romania’s Ana Maria Popescu took the gold medal in individual women’s epee at Estonia’s 50th annual “Glaive de Tallinn”. Poland also took the women’s epee gold medal in the team competition, which took place at the Kalev Sports Hall and drew 30 teams and 279 athletes from around the world. With the  2020 Olympic Games taking place next July, the qualification phase now underway for the “Road to Tokyo” gives heightened excitement to this and upcoming FIE world cups and Grand Prix events.",
        mobileHtml: `
          <p>In the first FIE senior world cup of the 2019-2020 international fencing competition season, Romania’s Ana Maria Popescu took the gold medal in individual women’s epee at Estonia’s 50th annual “Glaive de Tallinn”.</p>
          <p>Poland also took the women’s epee gold medal in the team competition, which took place at the Kalev Sports Hall and drew 30 teams and 279 athletes from around the world. With the 2020 Olympic Games taking place next July, the qualification phase now underway for the “Road to Tokyo” gives heightened excitement to this and upcoming FIE world cups and Grand Prix events. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 9,
        subIndex: 0,
        startIndex: 0,
        original: "pg10.jpg",
        zoom: null,
        content: `
        
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/113/en/static/_content/red-trophy.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/113/en/static/_content/red-yt.png">
        </a>

        <img class="halfScale pointer 10-arrow" style="top:845px;left:1387px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/10-arrow.png"> 

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg10Anim = new TimelineMax()
          pg10Anim
            .fromTo(cOf("10-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg10Anim.stop()
        }
      `,
        searchText:
          "Final ranking for individual women’s epee at the Tallinn World Cup included Ana Maria Popescu (ROU, gold), Violetta Kolobova (RUS, silver), Yiwen Sun (CHN, bronze), Mingye Zhu (CHN, bronze), Man Wai Vivian Kong (HKG), Leonora Mackinnon (CAN), Josephine Jacques Andre Coquin (FRA) and Nicol Foietta (ITA).  TALLINN WOMEN'S EPEE WORLD CUP TALLINN, ESTONIA 3 OF 3  Top-eight results for team women’s epee included Poland (gold), Russia (silver), USA (bronze), China, Estonia, Italy, Germany and Ukraine. ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  In the final round of individual women’s epee, Popescu defeated Russia’s Violetta Kolobova, 15-13. In the semi-final round, Kolobova beat China’s Mingye Zhu, 15-8, while Popescu narrowly overcame China’s Yiwen Sun, 15-14. The gold medal in women’s team epee was decided by a single touch, with Poland winning against Russia, 45-44. Russia overtook USA in the semi-final round, 45-29, and Poland beat China, 39-28. USA took the bronze over China, 43-35.  W W W.FIE .ORG",
        mobileHtml: `
          <p>In the final round of individual women’s epee, Popescu defeated Russia’s Violetta Kolobova, 15-13. In the semi-final round, Kolobova beat China’s Mingye Zhu, 15-8, while Popescu narrowly overcame China’s Yiwen Sun, 15-14.</p>
          <p>The gold medal in women’s team epee was decided by a single touch, with Poland winning against Russia, 45-44. Russia overtook USA in the semi-final round, 45-29, and Poland beat China, 39-28. USA took the bronze over China, 43-35.</p>
          <p><b>Final ranking for individual women’s epee at the Tallinn World Cup included:</b></p>
          <p>Ana Maria Popescu (ROU, gold)</p>
          <p>Violetta Kolobova (RUS, silver)</p>
          <p>Yiwen Sun (CHN, bronze)</p>
          <p>Mingye Zhu (CHN, bronze)</p>
          <p>Man Wai Vivian Kong (HKG)</p>
          <p>Leonora Mackinnon (CAN)</p>
          <p>Josephine Jacques Andre Coquin (FRA)</p>
          <p>Nicol Foietta (ITA)</p>
          <p><b>Top-eight results for team women’s epee included:</b></p>
          <p>Poland (gold)</p>
          <p>Russia (silver)</p>
          <p>USA (bronze)</p>
          <p>China, Estonia, Italy, Germany and Ukraine.</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 10,
        subIndex: 0,
        startIndex: 0,
        original: "pg11.jpg",
        zoom: null,
        content: `
      <img class="halfScale 11-title" style="top:140px;left:84px" src="/113/en/static/_content/11-title.png">

      <img class="halfScale 11-line" style="top:325px;left:84px" src="/113/en/static/_content/11-line.png">

      <img class="halfScale 11-sub" style="top:324px;left:128px" src="/113/en/static/_content/11-sub.png">

      <img class="halfScale pointer 11-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/11-arrow.png">
      `,
        script: `
        function onPageEnter() {
          pg11Anim = new TimelineMax()
          pg11Anim.fromTo(cOf("11-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("11-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("11-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("11-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg11Anim.stop()
        }
      `,
        searchText:
          "WORLD CUP  BONN MEN’S FOIL WORLD CUP BONN, GERMANY NOVEMBER 8-10, 2019",
        mobileHtml: `
          <h2>Bonn men's foil World Cup</h2>
          <img src="/113/en/static/_mobile/pg11.jpg" >
          <p><strong>Bonn, Germany<br>
          November 8-10, 2019</strong></p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 11,
        subIndex: 0,
        startIndex: 0,
        original: "pg12.jpg",
        zoom: null,
        content: `
        
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        
        
        <img class="halfScale pointer 12-arrow" style="top:845px;left:1406px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/12-arrow.png"> 
        
        `,
        script: `
        function onPageEnter() {
          pg12Anim = new TimelineMax()
          pg12Anim
            .fromTo(cOf("12-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg12Anim.stop()
        }
      `,
        searchText:
          "BONN MEN'S FOIL FENCING WORLD CUP BONN, GERMANY 2 OF 3  France’s Julien Mertine took the individual gold medal at the 2019 Bonn Men’s Foil World Cup, the 48th annual “Lowe von Bonn”, with USA winning gold in the team event. Taking place at Bonn’s Hardtberghalle, the competition drew 261 international foilists and teams from 26 countries. In the final round of individual men’s foil, Mertine defeated USA’s Gerek Meinhardt, 159. Both fencers overcame world champions in the semi-finals, with Meinhardt beating Italy’s Alessio Foconi, 15-12, and Mertine winning against Italy’s Andrea Cassara, 15-10. Notably,  Meinhardt advanced to the semi-finals against Italian Olympic champion Daniele Garozzo in the round of eight, 15-9, while Mertine beat Germany Olympic champion Benjamin Kleibrink, 15-3. In the men’s team foil final, USA beat Korea for the gold medal, 45-31. Korea defeated Italy,",
        mobileHtml: `
          <p>France’s Julien Mertine took the individual gold medal at the 2019 Bonn Men’s Foil World Cup, the 48th annual “Lowe von Bonn”, with USA winning gold in the team event.</p>
          <p>Taking place at Bonn’s Hardtberghalle, the competition drew 261 international foilists and teams from 26 countries. </p>
          <p>In the final round of individual men’s foil, Mertine defeated USA’s Gerek Meinhardt, 15-9. Both fencers overcame world champions in the semi-finals, with Meinhardt beating Italy’s Alessio Foconi, 15-12, and Mertine winning against Italy’s Andrea Cassara, 15-10. Notably, Meinhardt advanced to the semi-finals against Italian Olympic champion Daniele Garozzo in the round of eight, 15-9, while Mertine beat Germany Olympic champion Benjamin Kleibrink, 15-3. </p>
          <p>In the men’s team foil final, USA beat Korea for the gold medal, 45-31. Korea defeated Italy, 45-37, in the semi-final and USA won against Russia, 45-42. Russia took the bronze medal against Italy, 45-40.</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 12,
        subIndex: 0,
        startIndex: 0,
        original: "pg13.jpg",
        zoom: null,
        content: `
        
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/113/en/static/_content/red-yt.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/113/en/static/_content/red-trophy.png">
        </a>
        
        <img class="halfScale pointer 13-arrow" style="top:845px;left:1387px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/13-arrow.png"> 

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg13Anim = new TimelineMax()
          pg13Anim
            .fromTo(cOf("13-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg13Anim.stop()
        }
      `,
        searchText:
          "BONN MEN'S FOIL FENCING WORLD CUP BONN, GERMANY 3 OF 3  45-37, in the semi-final and USA won against Russia, 45-42. Russia took the bronze medal against Italy, 45-40. Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  In men’s team foil, final ranking included USA (gold), Korea (silver), Russia (bronze), Italy, France, Hong Kong, Japan and Germany. ■  Final ranking in the men’s individual foil event included Julien Mertine (FRA, gold), Gerek Meinhardt (USA, silver), Andrea Cassara (ITA, bronze), Alessio Foconi (ITA, bronze), Daniele Garozzo (ITA), Kyosuke Matsuyama (JPN), Benjamin Kleibrink (GER) and Carlos Llavador (ESP).  W W W.FIE .ORG",
        mobileHtml: `
          <p><b>Final ranking in the men’s individual foil event included: </b></p>
          <p> Julien Mertine (FRA, gold)</p>
          <p>Gerek Meinhardt (USA, silver) </p>
          <p>Andrea Cassara (ITA, bronze)</p>
          <p>Alessio Foconi (ITA, bronze) </p>
          <p>Daniele Garozzo (ITA) </p>
          <p>Kyosuke Matsuyama (JPN) </p>
          <p>Benjamin Kleibrink (GER) </p>
          <p>Carlos Llavador (ESP) </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 13,
        subIndex: 0,
        startIndex: 0,
        original: "pg14.jpg",
        zoom: null,
        content: `
        <svg class="abs pulse animatedpulse pointer" onclick="Publish.openVideo('/113/en/static/_content/11-vid.m4v')" style="bottom:460px;left:1146px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
          <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
        </svg>
      `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
        <a href="http://www.allstar.de" target="_blank">
        <img src="/113/en/static/_mobile/pg14.jpg">
      </a>
      
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 14,
        subIndex: 0,
        startIndex: 0,
        original: "pg15.jpg",
        zoom: null,
        content: `
        
        <img class="halfScale 15-title" style="top:140px;left:84px" src="/113/en/static/_content/15-title.png">

        <img class="halfScale 15-line" style="top:325px;left:84px" src="/113/en/static/_content/15-line.png">

        <img class="halfScale 15-sub" style="top:324px;left:126px" src="/113/en/static/_content/15-sub.png">

        <img class="halfScale pointer 15-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/15-arrow.png">
      `,
        script: `
        function onPageEnter() {
          pg15Anim = new TimelineMax()
          pg15Anim.fromTo(cOf("15-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("15-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("15-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("15-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg15Anim.stop()
        }
      `,
        searchText:
          "WORLD CUP  CAIRO MEN’S SABRE WORLD CUP CAIRO, EGYPT NOVEMBER 15-17, 2019",
        mobileHtml: `
          <h2>Cairo men's sabre World Cup</h2>
          <img src="/113/en/static/_mobile/pg15.jpg" >
          <p><strong>Cairo, Egypt<br>
          November 15-17, 2019</strong><p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 15,
        subIndex: 0,
        startIndex: 0,
        original: "pg16.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/113/en/static/_content/red-trophy.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/113/en/static/_content/red-yt.png">
        </a>
        
        <img class="halfScale pointer 16-arrow" style="top:845px;left:1409px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/16-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg16Anim = new TimelineMax()
          pg16Anim
            .fromTo(cOf("16-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg16Anim.stop()
        }`,
        searchText:
          "CAIRO MEN'S SABRE WORLD CUP CAIRO, EGYPT 2 OF 2  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  France’s Vincent Anstett won the men’s individual gold medal at the 2019 Cairo Men’s Sabre World Cup, and Korea took the gold in the men’s team event.  event included Vincent Anstett (FRA, gold), Luigi Samele (ITA, silver), Fares Ferjani (TUN, bronze), Junghwan Kim (KOR, bronze), Bolade Apithy (FRA), Mohamed Amer (EGY), Gabriele Foschini (ITA) and Riccardo Nuccio (ITA).  The event took place at the Cairo Stadium Indoor Halls Complex with 194 international men’s sabre fencers and teams from 26 countries.  In men’s team sabre, final ranking included Korea (gold), Hungary (silver), Italy (bronze), Russia, Germany, Iran, China and France. ■  Anstett took on Italy’s Luigi Samele in the goldmedal match of the men’s individual sabre event, winning by a single point, 15-14. Samele overcame Tunisia’s Fares Ferjani in the semifinal round, 15-8, and Anstett beat Korea’s world champion Junghwan Kim in another close bout, 15-14. Notably, world champions Andras Szatmari (HUN) and Veniamin Reshetnikov (RUS) finished in the top 16. In men’s team sabre, Korea faced Hungary in the final round, taking gold with a 45-41 score. Hungary beat Italy in the semi-final round, 45-37, and Korea defeated Russia, 45-39. The bronze medal went to Italy over Russia, 45-31. Final ranking in the men’s individual sabre  W W W.FIE .ORG",
        mobileHtml: `
          <p>France’s Vincent Anstett won the men’s individual gold medal at the 2019 Cairo Men’s Sabre World Cup, and Korea took the gold in the men’s team event.</p>
          <p>The event took place at the Cairo Stadium Indoor Halls Complex with 194 international men’s sabre fencers and teams from 26 countries.</p>
          <p>In men’s team sabre, Korea faced Hungary in the final round, taking gold with a 45-41 score. Hungary beat Italy in the semi-final round, 45-37, and Korea defeated Russia, 45-39. The bronze medal went to Italy over Russia, 45-31.</p>
          <p><b>Final ranking in the men’s individual sabre event included: </b></p>
          <p>Vincent Anstett (FRA, gold) </p>
          <p>Luigi Samele (ITA, silver) </p>
          <p>Fares Ferjani (TUN, bronze) </p>
          <p>Junghwan Kim (KOR, bronze) </p>
          <p>Bolade Apithy (FRA) </p>
          <p>Mohamed Amer (EGY) </p>
          <p>Abriele Foschini (ITA) </p>
          <p>Riccardo Nuccio (ITA) </p>
          <p><b>In men’s team sabre, final ranking included:</b></p>
          <p>Korea (gold) </p>
          <p>Hungary (silver) </p>
          <p>Italy (bronze) </p>
          <p>Russia, Germany, Iran, China and France. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 16,
        subIndex: 0,
        startIndex: 0,
        original: "pg17.jpg",
        zoom: null,
        content: `
        <img class="halfScale 17-title" style="top:141px;left:84px" src="/113/en/static/_content/17-title.png">

        <img class="halfScale 17-line" style="top:245px;left:84px" src="/113/en/static/_content/17-line.png">

        <img class="halfScale 17-sub" style="top:245px;left:127px" src="/113/en/static/_content/17-sub.png">

        <img class="halfScale pointer 17-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/17-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg17Anim = new TimelineMax()
          pg17Anim.fromTo(cOf("17-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("17-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("17-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("17-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg17Anim.stop()
        }
      `,
        searchText:
          "WORLD CUP  BERNE MEN’S EPEE WORLD CUP BERNE, SWITZERLAND NOVEMBER 22-24, 2019",
        mobileHtml: `
          <h2>Berne men's epee World Cup</h2>
          <img src="/113/en/static/_mobile/pg17.jpg" >
          <p><strong>Berne, Switzerland<br>
          November 22-24, 2019</strong><p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 17,
        subIndex: 0,
        startIndex: 0,
        original: "pg18.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/113/en/static/_content/red-trophy.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/113/en/static/_content/red-yt.png">
        </a>
        
        <img class="halfScale pointer 18-arrow" style="top:845px;left:1409px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/16-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
      `,
        script: `
        function onPageEnter() {
          pg18Anim = new TimelineMax()
          pg18Anim
            .fromTo(cOf("18-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg18Anim.stop()
        }
      `,
        searchText:
          "BERNE MEN'S EPEE WORLD CUP BERNE, SWITZERLAND 2 OF 2  Ukraine’s Igor Reizlin took the gold medal at the “Tissot Grand Prix de Berne” Men’s Epee World Cup, with France winning the team gold medal men’s team event. Taking place at Berne’s Haus des Sports, the event drew 324 international men’s epee fencers and teams from 31 countries. Reizlin faced Russia’s Vadim Anokhin in the final round of the men’s individual epee competition, winning closely with a 11-10 score to take  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  the gold medal. Anokhin defeated Ukraine’s Roman Svichkar in the semi-final round, 15-8, and Reizlin beat France’s Alexandre Bardenet, 15-10. Notably, French world champion Yannick Borel lost to Reizlin in the quarter-finals, 1512, while Olympic champions Ruben Limardo Gascon (VEN) and Sangyoung Park (KOR) were beaten in the round of 16. Team France had a close win in the final round of men’s team epee, overcoming Team Italy 45-44. In the semi-final, Italy beat Ukraine, 3231, and France beat Japan, 45-40. The bronze medal went to Ukraine over Japan, also by a single touch, 32-31. Final individual rankings in the Berne Men’s Epee World Cup included Igor Reizlin (UKR, gold), Vadim Anokhin (RUS, silver), Alexandre Bardenet (FRA, bronze), Roman Svichkar (UKR, bronze), Bogdan Nikishin (UKR), Yannick Borel (FRA), Houssam Elkord (MAR) and Tibor Andrasfi (HUN). Team rankings included France (gold), Italy (silver), Ukraine (bronze), Japan, Korea, China, Switzerland and Poland. ■  W W W.FIE .ORG",
        mobileHtml: `
          <p>Ukraine’s Igor Reizlin took the gold medal at the “Tissot Grand Prix de Berne” Men’s Epee World Cup, with France winning the team gold medal men’s team event. </p>
          <p>Taking place at Berne’s Haus des Sports, the event drew 324 international men’s epee fencers and teams from 31 countries. </p>
          <p>Reizlin faced Russia’s Vadim Anokhin in the final round of the men’s individual epee competition, winning closely with a 11-10 score to take the gold medal. Anokhin defeated Ukraine’s Roman Svichkar in the semi-final round, 15-8, and Reizlin beat France’s Alexandre Bardenet, 15-10. Notably, French world champion Yannick Borel lost to Reizlin in the quarter-finals, 15-12, while Olympic champions Ruben Limardo Gascon (VEN) and Sangyoung Park (KOR) were beaten in the round of 16. </p>
          <p>Team France had a close win in the final round of men’s team epee, overcoming Team Italy 45-44. In the semi-final, Italy beat Ukraine, 32-31, and France beat Japan, 45-40. The bronze medal went to Ukraine over Japan, also by a single touch, 32-31. </p>
          <p><b>Final individual rankings in the Berne Men’s Epee World Cup included: </b></p>
          <p>Igor Reizlin (UKR, gold) </p>
          <p>Vadim Anokhin (RUS, silver) </p>
          <p>Alexandre Bardenet (FRA, bronze) </p>
          <p>Roman Svichkar (UKR, bronze) </p>
          <p>Bogdan Nikishin (UKR)</p>
          <p>Yannick Borel (FRA) </p>
          <p>Houssam Elkord (MAR) </p>
          <p>Tibor Andrasfi (HUN) </p>
          <p><b>Team rankings included </b></p>
          <p>France (gold) </p>
          <p>Italy (silver) </p>
          <p>Ukraine (bronze) </p>
          <p>Japan, Korea, China, Switzerland and Poland. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 18,
        subIndex: 0,
        startIndex: 0,
        original: "pg19.jpg",
        zoom: null,
        content: `
        <a href="https://www.blaise-freres.fr" target="_blank">
            <div class="contentLinkNone" style="bottom:331px;right:1053px;width:256px; height:30px;"></div>
          </a>
        `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
        <img src="/113/en/static/_mobile/pg19.jpg">
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 19,
        subIndex: 0,
        startIndex: 0,
        original: "pg20.jpg",
        zoom: null,
        content: `
          <a href="http://www.fencingsets.com" target="_blank">
            <div class="contentLinkNone" style="top:864px;left:283px;width:228px; height:30px;"></div>
          </a>

          <a href="mailto:755037302@qq.com">
            <div class="contentLinkNone" style="top:894px;left:283px;width:215px; height:30px;"></div>
          </a>

          <a href="mailto:1135864400@qq.com">
            <div class="contentLinkNone" style="top:894px;left:500px;width:173px; height:30px;"></div>
          </a>
        `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
        <img src="/113/en/static/_mobile/pg20.jpg">
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 20,
        subIndex: 0,
        startIndex: 0,
        original: "pg21.jpg",
        zoom: null,
        content: `
        <img class="halfScale 21-title" style="top:264px;left:82px" src="/113/en/static/_content/21-title.png">

        <img class="halfScale 21-line" style="top:550px;left:84px" src="/113/en/static/_content/21-line.png">

        <img class="halfScale 21-sub" style="top:544px;left:126px" src="/113/en/static/_content/21-sub.png">

       <img class="halfScale pointer 21-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/21-arrow.png">
      `,
        script: `
        function onPageEnter() {
          pg21Anim = new TimelineMax()
          pg21Anim.fromTo(cOf("21-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("21-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("21-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("21-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg21Anim.stop()
        }
      `,
        searchText:
          "WORLD CUP  ORLÉANS WOMEN’S SABRE WORLD CUP ORLÉANS, FRANCE NOVEMBER 22-24, 2019",
        mobileHtml: `
          <h2>Orléans women's sabre World Cup</h2>
          <img src="/113/en/static/_mobile/pg21.jpg" >
          <p><strong>Orléans, France<br>
          November 22-24, 2019</strong><p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 21,
        subIndex: 0,
        startIndex: 0,
        original: "pg22.jpg",
        zoom: null,
        content: `
        <img class="halfScale pointer 22-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/22-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg22Anim = new TimelineMax()
          pg22Anim.fromTo(cOf("22-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg22Anim.stop()
        }
      `,
        searchText:
          "ORLÉANS WOMEN'S SABRE WORLD CUP ORLÉANS, FRANCE 2 OF 3  France’s Manon Brunet won the individual gold medal at the Orleans “Trophée Orcom” Women’s Sabre World Cup, with Russia taking the gold in the team competition. Finals took place at the City’s Zenith d’Orléans, with 212 international women’s sabre fencers participating along with teams from 26 countries. Brunet fenced Russia’s Olga Nikitina in the final match, winning with a 15-12 score. Nikitina beat  China’s Yaqi Shao in the semi-final, 15-11, while Brunet narrowly defeated four-time Ukrainian world champion Olga Kharlan, 15-14. Brunet beat Korean Olympic champion Jiyeon Kim in the quarter-final round, 15-4, while Kharlan overtook Russian world champion Sofia Pozdniakova, 15-10. Of note, Russian Olympic champion Yana Egorian was eliminated by France’s Charlotte Lembach in the table of 16, 15-13, after beating her teammate and twotime Russian world champion, Sofya Velikaya, 15-10, in the round of 32.",
        mobileHtml: `
          <p>France’s Manon Brunet won the individual gold medal at the Orleans “Trophée Orcom” Women’s Sabre World Cup, with Russia taking the gold in the team competition. </p>
          <p>Finals took place at the City’s Zenith d’Orléans, with 212 international women’s sabre fencers participating along with teams from 26 countries. </p>
          <p>Brunet fenced Russia’s Olga Nikitina in the final match, winning with a 15-12 score. Nikitina beat China’s Yaqi Shao in the semi-final, 15-11, while Brunet narrowly defeated four-time Ukrainian world champion Olga Kharlan, 15-14. Brunet beat Korean Olympic champion Jiyeon Kim in the quarter-final round, 15-4, while Kharlan overtook Russian world champion Sofia Pozdniakova, 15-10. Of note, Russian Olympic champion Yana Egorian was eliminated by France’s Charlotte Lembach in the table of 16, 15-13, after beating her teammate and two-time Russian world champion, Sofya Velikaya, 15-10, in the round of 32. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 22,
        subIndex: 0,
        startIndex: 0,
        original: "pg23.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/113/en/static/_content/red-trophy.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/113/en/static/_content/red-yt.png">
        </a>
        
        <img class="halfScale pointer 23-arrow" style="top:845px;left:1409px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/23-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg23Anim = new TimelineMax()
          pg23Anim
            .fromTo(cOf("23-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg23Anim.stop()
        }
      `,
        searchText:
          "ORLÉANS WOMEN'S SABRE WORLD CUP ORLÉANS, FRANCE 3 OF 3  In the women’s team sabre competition, Russia took the gold medal against Korea, 45-41. Korea beat Ukraine in the semi-final round, 45-43, while Russia beat Hungary, 4526. The bronze medal went to Ukraine over Hungary, 45-36. Final individual rankings in the Orleans Women’s Sabre World Cup included Manon  Brunet (FRA, gold), Olga Nikitina (RUS, silver), Olga Kharlan (UKR, bronze), Yaqi Shao (CHN, bronze), Jiyeon Kim (KOR), Sofia Pozdniakova (RUS), Bianca Pascu (ROU) and Charlotte Lembach (FRA). Team rankings included Russia (gold), Korea (silver), Ukraine (bronze), Hungary, France, Italy, China and Spain. ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  W W W.FIE .ORG",
        mobileHtml: `
          <p>In the women’s team sabre competition, Russia took the gold medal against Korea, 
          45-41. Korea beat Ukraine in the semi-final round, 45-43, while Russia beat Hungary, 45-26. The bronze medal went to Ukraine over Hungary, 45-36.</p>
          <p><b>Final individual rankings in the Orleans Women’s Sabre World Cup included: </b></p>
          <p>Manon Brunet (FRA, gold) </p>
          <p>Olga Nikitina (RUS, silver) </p>
          <p>Olga Kharlan (UKR, bronze) </p>
          <p>Yaqi Shao (CHN, bronze) </p>
          <p>Jiyeon Kim (KOR) </p>
          <p>Sofia Pozdniakova (RUS) </p>
          <p>Bianca Pascu (ROU) </p>
          <p>Charlotte Lembach (FRA) </p>
          <p><b>Team rankings included</b></p>
          <p>Russia (gold)</p>
          <p>Korea (silver) </p>
          <p>Ukraine (bronze) </p>
          <p>Hungary, France, Italy, China and Spain. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 23,
        subIndex: 0,
        startIndex: 0,
        original: "pg24.jpg",
        zoom: null,
        content: `
        <img class="halfScale 24-title" style="top:123px;left:664px" src="/113/en/static/_content/24-title.png">

        <img class="halfScale 24-line" style="top:302px;left:667px" src="/113/en/static/_content/24-line.png">

        <img class="halfScale 24-sub" style="top:303px;left:710px" src="/113/en/static/_content/24-sub.png">

       <img class="halfScale pointer 24-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/24-arrow.png">
       `,
        script: `
        function onPageEnter() {
          pg24Anim = new TimelineMax()
          pg24Anim.fromTo(cOf("24-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("24-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("24-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("24-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg24Anim.stop()
        }
      `,
        searchText:
          "WORLD CUP  CAIRO WOMEN’S FOIL WORLD CUP CAIRO, EGYPT NOVEMBER 22-24, 2019",
        mobileHtml: `
          <h2>Cairo women's foil World Cup</h2>
          <img src="/113/en/static/_mobile/pg24.jpg" >
          <p><strong>Cairo, Egypt<br>
          November 22-24, 2019</strong><p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 24,
        subIndex: 0,
        startIndex: 0,
        original: "pg25.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <img class="halfScale pointer 25-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/25-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg25Anim = new TimelineMax()
          pg25Anim
            .fromTo(cOf("25-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg25Anim.stop()
        }
      `,
        searchText:
          "CAIRO WOMEN'S FOIL WORLD CUP CAIRO, EGYPT 2 OF 3  Italian two-time world champion Arianna Errigo won individual gold at the Cairo Women’s Foil World Cup, and Italy took the team gold medal. The event took place at the Cairo Stadium Indoor Halls Complex, with 170 international women’s foilists competing along with teams from 17 countries. In the gold-medal final, Errigo faced China’s Yue Shi, winning with a 15-6 score. Shi  overtook Italian Olympic and world champion Elisa Di Francisca in the semi-final round, 1511, and Errigo closely defeated France’s Ysaora Thibus, 15-14. Of note, Thibus beat Russian Olympic and three-time world champion Inna Deriglazova in the quarter-finals, 15-13.",
        mobileHtml: `
          <p>Italian two-time world champion Arianna Errigo won individual gold at the Cairo Women’s Foil World Cup, and Italy took the team gold medal </p>
          <p>The event took place at the Cairo Stadium Indoor Halls Complex, with 170 international women’s foilists competing along with teams from 17 countries. </p>
          <p>In the gold-medal final, Errigo faced China’s Yue Shi, winning with a 15-6 score. Shi overtook Italian Olympic and world champion Elisa Di Francisca in the semi-final round, 15-11, and Errigo closely defeated France’s Ysaora Thibus, 15-14. Of note, Thibus beat Russian Olympic and three-time world champion Inna Deriglazova in the quarter-finals, 15-13. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 25,
        subIndex: 0,
        startIndex: 0,
        original: "pg26.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/113/en/static/_content/red-trophy.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/113/en/static/_content/red-yt.png">
        </a>
        
        <img class="halfScale pointer 26-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/26-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg26Anim = new TimelineMax()
          pg26Anim
            .fromTo(cOf("26-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg26Anim.stop()
        }
      `,
        searchText:
          "(FRA, bronze), Inna Deriglazova (RUS), Lee Kiefer (USA), Rio Azuma (JPN) and Martina Batini (ITA).  CAIRO WOMEN'S FOIL WORLD CUP CAIRO, EGYPT 3 OF 3  Team women’s foil final rankings included Italy (gold), Russia (silver), France (bronze), USA, Canada, Hungary, China and Germany. ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  Italy defeated Russia in the final round of the women’s team foil event, 42-40. Russia beat USA in the semi-final, 45-34, and Italy overcame France, 45-38. The bronze medal went to France over USA, 45-40. Final rankings for the Cairo Women’s Foil World Cup individual event included Arianna Errigo (ITA, gold), Yue Shi (CHN, silver), Elisa Di Francisca (ITA, bronze), Ysaora Thibus  W W W.FIE .ORG",
        mobileHtml: `
          <p>Italy defeated Russia in the final round of the women’s team foil event, 42-40. Russia beat USA in the semi-final, 45-34, and Italy overcame France, 45-38. The bronze medal went to France over USA, 45-40. </p>
          <p><b>Final rankings for the Cairo Women’s Foil World Cup individual event included: </b> </p>
          <p>Arianna Errigo (ITA, gold) </p>
          <p>Yue Shi (CHN, silver) </p>
          <p>Elisa Di Francisca (ITA, bronze) </p>
          <p>Ysaora Thibus  (FRA, bronze) </p>
          <p>Inna Deriglazova (RUS) </p>
          <p>Lee Kiefer (USA) </p>
          <p>Rio Azuma (JPN) </p>
          <p>Martina Batini (ITA) </p>
          <p><b>Team women’s foil final rankings included: </b> </p>
          <p>Italy (gold) </p>
          <p> Russia (silver)</p>
          <p>France (bronze) </p>
          <p>USA, Canada, Hungary, China and Germany. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 26,
        subIndex: 0,
        startIndex: 0,
        original: "pg27.jpg",
        zoom: null,
        content: `
        <a href="http://www.blue-gauntlet.com" target="_blank">
            <div class="contentLinkNone" style="top:939px;left:250px;width:1080px; height:75px;"></div>
          </a>
          
          <a href="mailto:service@blue-gauntletservice.com">
            <div class="contentLinkNone" style="top:1028px;left:384px;width:823px; height:49px;"></div>
          </a>
          `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `  
        <a href="http://www.blue-gauntlet.com" target="_blank">
        <img src="/113/en/static/_mobile/pg27.jpg">
        </a>
      `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 27,
        subIndex: 0,
        startIndex: 0,
        original: "pg28.jpg",
        zoom: null,
        content: `
        <img class="halfScale 28-title" style="top:131px;left:498px" src="/113/en/static/_content/28-title.png">

        <img class="halfScale 28-line" style="top:289px;left:1018px" src="/113/en/static/_content/28-line.png">

        <img class="halfScale 28-sub" style="top:287px;left:1061px" src="/113/en/static/_content/28-sub.png">

        <img class="halfScale pointer 28-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/28-arrow.png">
      `,
        script: `
        function onPageEnter() {
          pg28Anim = new TimelineMax()
          pg28Anim.fromTo(cOf("28-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("28-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("28-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("28-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg28Anim.stop()
        }
      `,
        searchText:
          "WORLD CUP  SAINT-MAUR WOMEN’S FOIL SAINT-MAUR, FRANCE WORLD CUP DECEMBER 13-15, 2019",
        mobileHtml: `
          <h2>Saint-Maur women's foil World Cup </h2>
          <img src="/113/en/static/_mobile/pg28.jpg" >
          <p><strong>Saint-Maur, France<br>
          December 13-15, 2019</strong><p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 28,
        subIndex: 0,
        startIndex: 0,
        original: "pg29.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <img class="halfScale pointer 29-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/29-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg29Anim = new TimelineMax()
          pg29Anim
            .fromTo(cOf("29-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg29Anim.stop()
        }
      `,
        searchText:
          "SAINT-MAUR WOMEN'S FOIL FENCING WORLD CUP SAINT-MAUR, FRANCE 2 OF 3  Italy’s world champion Alice Volpi won the individual gold medal at the Saint-Maur Women’s Foil World Cup, with Russia taking gold in women’s team foil. The event, which took place at the City’s Sport Centre Pierre Brossolette, featured 205 international women’s foilists and 23 teams. Volpi fenced her teammate, Martina Batini, in the final round, taking the gold medal with a  15-10 score. Batini narrowly defeated Russia’s Olympic and three-time world champion Inna Deriglazova in the semi-final round, 15-14, while Volpi beat USA’s Lee Kiefer, 15-13. Notably, Kiefer overcame Italian two-time world champion Arianna Errigo in the quarter-finals,",
        mobileHtml: `
          <p>Italy’s world champion Alice Volpi won the individual gold medal at the Saint-Maur Women’s Foil World Cup, with Russia taking gold in women’s team foil. </p>
          <p>The event, which took place at the City’s Sport Centre Pierre Brossolette, featured 205 international women’s foilists and 23 teams. </p>
          <p>Volpi fenced her teammate, Martina Batini, in the final round, taking the gold medal with a 15-10 score. Batini narrowly defeated Russia’s Olympic and three-time world champion Inna Deriglazova in the semi-final round, 15-14, while Volpi beat USA’s Lee Kiefer, 15-13. Notably, Kiefer overcame Italian two-time world champion Arianna Errigo in the quarter-finals, 15-11, and Italy’s Olympic and world champion Elisa Di Francisca was eliminated in the round of 16 by Russia’s Adelina Zagidullina, 15-11.</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 29,
        subIndex: 0,
        startIndex: 0,
        original: "pg30.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/113/en/static/_content/red-trophy.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/113/en/static/_content/red-yt.png">
        </a>
        
        <img class="halfScale pointer 30-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/30-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg30Anim = new TimelineMax()
          pg30Anim
            .fromTo(cOf("30-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg30Anim.stop()
        }
      `,
        searchText:
          "SAINT-MAUR WOMEN'S FOIL FENCING WORLD CUP SAINT-MAUR, FRANCE 3 OF 3  15-11, and Italy’s Olympic and world champion Elisa Di Francisca was eliminated in the round of 16 by Russia’s Adelina Zagidullina, 15-11. For the women’s team foil gold medal, Russia overcame Italy by a single touch, 42-41. Italy beat Hungary in the semi-final, 45-28, and Russia defeated Japan, 40-21. The bronze medal went to Japan over Hungary, 45-32.  (FRA), Adelina Zagidullina (RUS) and Anita Blaze (FRA). Ranking for women’s team foil included Russia (gold), Italy (silver), Japan (bronze), Hungary, France, USA, China and Poland. ■  Final individual rankings at the Saint-Maur Women’s Foil World Cup included Alice Volpi (ITA, gold), Martina Batini (ITA, silver), Inna Deriglazova (RUS, bronze), Lee Kiefer (USA, bronze), Arianna Errigo (ITA), Ysaora Thibus  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  W W W.FIE .ORG",
        mobileHtml: `
          <p>For the women’s team foil gold medal, Russia overcame Italy by a single touch, 42-41. Italy beat Hungary in the semi-final, 45-28, and Russia defeated Japan, 40-21. The bronze medal went to Japan over Hungary, 45-32. </p>
          <p><b>Final individual rankings at the Saint-Maur Women’s Foil World Cup included: </b> </p>
          <p>Alice Volpi (ITA, gold) </p>
          <p>Martina Batini (ITA, silver) </p>
          <p>Inna Deriglazova (RUS, bronze) </p>
          <p>Lee Kiefer (USA, bronze) </p>
          <p>Arianna Errigo (ITA) </p>
          <p>Ysaora Thibus (FRA) </p>
          <p>Adelina Zagidullina (RUS) </p>
          <p>Anita Blaze (FRA) </p>
          <p><b>Ranking for women’s team foil included: </b> </p>
          <p>Russia (gold) </p>
          <p>Italy (silver) </p>
          <p>Japan (bronze) </p>
          <p>Hungary, France, USA, China and Poland. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 30,
        subIndex: 0,
        startIndex: 0,
        original: "pg31.jpg",
        zoom: null,
        content: `
        <a href="http://favero.com" target="_blank">
            <div class="contentLinkNone" style="top:769px;left:1000px;width:165px; height:55px;"></div>
          </a>
          `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
      
      <a href="http://favero.com" target="_blank">
        <img src="/113/en/static/_mobile/pg31.jpg">
      </a>

      `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 31,
        subIndex: 0,
        startIndex: 0,
        original: "pg32.jpg",
        zoom: null,
        content: `
        <a href="http://www.jiangfencing.com" target="_blank">
            <div class="contentLinkNone" style="top:1000px;left:816px;width:223px; height:25px;"></div>
          </a>

          <a href="mailto:jason@jiangfencing.com">
            <div class="contentLinkNone" style="top:1025px;left:828px;width:239px; height:25px;"></div>
          </a>
          `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
      
      <a href="http://www.jiangfencing.com" target="_blank">
        <img src="/113/en/static/_mobile/pg32.jpg">
      </a>

      `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 32,
        subIndex: 0,
        startIndex: 0,
        original: "pg33.jpg",
        zoom: null,
        content: `
        <img class="halfScale 33-title" style="top:238px;left:84px" src="/113/en/static/_content/33-title.png">

        <img class="halfScale 33-line" style="top:479px;left:289px" src="/113/en/static/_content/33-line.png">

        <img class="halfScale 33-sub" style="top:478px;left:332px" src="/113/en/static/_content/33-sub.png">

       <img class="halfScale pointer 33-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/33-arrow.png">
       `,
        script: `
        function onPageEnter() {
          pg33Anim = new TimelineMax()
          pg33Anim.fromTo(cOf("33-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("33-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("33-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("33-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg33Anim.stop()
        }
      `,
        searchText:
          "WORLD CUP  SALT LAKE CITY WOMEN’S SABRE WORLD CUP SALT LAKE CITY, USA DECEMBER 13-15, 2019",
        mobileHtml: `
          <h2>Salt Lake City women's sabre World Cup</h2>
          <img src="/113/en/static/_mobile/pg33.jpg" >
          <p><strong>Salt Lake City, USA<br>
          December 13-15, 2019</strong></p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 33,
        subIndex: 0,
        startIndex: 0,
        original: "pg34.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/113/en/static/_content/red-trophy.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/113/en/static/_content/red-yt.png">
        </a>
        
        <img class="halfScale pointer 34-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/34-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg34Anim = new TimelineMax()
          pg34Anim
            .fromTo(cOf("34-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg34Anim.stop()
        }
      `,
        searchText:
          "WOMEN'S SABRE WORLD CUP IN SALT LAKE CITY SALT LAKE CITY, USA 2 OF 2  Ukraine’s four-time world champion Olga Kharlan scored the individual gold medal at the Absolute Fencing Gear Women’s Sabre World Cup in Salt Lake City, with France taking the gold in the women’s team event. Held at the Salt Palace Convention Center, the competition drew 185 women’s sabre fencers and 25 teams from around the world.  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  Kharlan faced China’s Jiarui Qian in the final round, winning with a 15-9 score. Qian defeated Korea’s Jiyeon Seo by one point in the semi-final, 15-14, and Kharlan beat France’s Manon Brunet, 15-9. Two-time Russian world champion Sofya Velikaya lost in the round of 16 to France’s Sarah Noutcha, 15-13, while Ukraine’s Alina Komashchuk beat Russian world champion Sofia Pozdniakova, 15-12, and Kharlan defeated USA’s two-time Olympic and world champion Mariel Zagunis, 15-9. In the women’s team sabre event, France overcame Hungary for the gold medal, 45-25. Hungary eliminated Ukraine in the semi-final,  45-42, and France beat USA, 45-31. The bronze medal went to USA over Ukraine, 45-39. Final individual ranking for the Absolute Fencing Gear Women’s Sabre World Cup included Olga Kharlan (UKR, gold), Jiarui Qian (CHN, silver), Manon Brunet (FRA, bronze), Jiyeon Seo (KOR, bronze), Misaki Emura (JPN), Alina Komashchuk (UKR), Anna Limbach (GER) and Sarah Noutcha (FRA). Team ranking included France (gold), Hungary (silver), USA (bronze), Ukraine, Italy, Korea, China and Russia. ■  W W W.FIE .ORG",
        mobileHtml: `
          <p>Ukraine’s four-time world champion Olga Kharlan scored the individual gold medal at the Absolute Fencing Gear Women’s Sabre World Cup in Salt Lake City, with France taking the gold in the women’s team event.</p>
          <p>Held at the Salt Palace Convention Center, the competition drew 185 women’s sabre fencers and 25 teams from around the world. </p>
          <p>Kharlan faced China’s Jiarui Qian in the final round, winning with a 15-9 score. Qian defeated Korea’s Jiyeon Seo by one point in the semi-final, 15-14, and Kharlan beat France’s Manon Brunet, 15-9. Two-time Russian world champion Sofya Velikaya lost in the round of 16 to France’s Sarah Noutcha, 15-13, while Ukraine’s Alina Komashchuk beat Russian world champion Sofia Pozdniakova, 15-12, and Kharlan defeated USA’s two-time Olympic and world champion Mariel Zagunis, 15-9. </p>
          <p>In the women’s team sabre event, France overcame Hungary for the gold medal, 45-25. Hungary eliminated Ukraine in the semi-final, 45-42, and France beat USA, 45-31. The bronze medal went to USA over Ukraine, 45-39. </p>
          <p><b>Final individual ranking for the Absolute Fencing Gear Women’s Sabre World Cup included: </b></p>
          <p>Olga Kharlan (UKR, gold) </p>
          <p>Jiarui Qian (CHN, silver) </p>
          <p>Manon Brunet (FRA, bronze) </p>
          <p>Jiyeon Seo (KOR, bronze) </p>
          <p>Misaki Emura (JPN) </p>
          <p>Alina Komashchuk (UKR) </p>
          <p>Anna Limbach (GER) </p>
          <p>Sarah Noutcha (FRA) </p>
          <p><b> </b></p>
          <p><b>Team ranking included: </b></p>
          <p>France (gold) </p>
          <p>Hungary (silver) </p>
          <p>USA (bronze) </p>
          <p>Ukraine, Italy, Korea, China and Russia. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 34,
        subIndex: 0,
        startIndex: 0,
        original: "pg35.jpg",
        zoom: null,
        content: `
        <img class="halfScale 35-title" style="top:164px;left:803px" src="/113/en/static/_content/35-title.png">

        <img class="halfScale 35-line" style="top:523px;left:802px" src="/113/en/static/_content/35-line.png">

        <img class="halfScale 35-sub" style="top:522px;left:844.9px" src="/113/en/static/_content/35-sub.png">

       <img class="halfScale pointer 35-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/35-arrow.png">
       `,
        script: `
        function onPageEnter() {
          pg35Anim = new TimelineMax()
          pg35Anim.fromTo(cOf("35-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("35-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("35-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("35-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg35Anim.stop()
        }
      `,
        searchText:
          "WORLD CUP  TOKYO MEN’S FOIL WORLD CUP AND OLYMPIC TEST EVENT TOKYO, JAPAN DECEMBER 13-15, 2019",
        mobileHtml: `
          <h2>Tokyo men's foil World Cup and Olympic test event</h2>
          <img src="/113/en/static/_mobile/pg35.jpg" >
          <p><strong>Tokyo, Japan<br>
          December 13-15, 2019</strong></p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 35,
        subIndex: 0,
        startIndex: 0,
        original: "pg36.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <img class="halfScale pointer 36-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/36-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg36Anim = new TimelineMax()
          pg36Anim
            .fromTo(cOf("36-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg36Anim.stop()
        }
      `,
        searchText:
          "TOKYO MEN'S FOIL WORLD CUP AND OLYMPIC TEST EVENT TOKYO, JAPAN 2 OF 3  Italian world champion Alessio Foconi took the men’s individual foil gold medal at the 2019 H.I.H. Prince Takamado Trophy Men’s Foil World Cup in Tokyo, with France winning men’s team foil. The competition drew 211 men’s foilists and 19 teams from around the world. This World Cup, which was also an official Test Event for fencing, took place in the Makuhari Messe in Chiba City where fencing will be held at the 2020 Olympic Games.  Foconi won the final match of the men’s individual foil event against France’s Maxime Pauty, 15-5. Pauty defeated Russian world champion Alexey Cheremisinov in the semi-final round, 15-10, while Foconi beat teammate and Olympic champion Daniele Garozzo, 15-10. Notably, Foconi overcame another teammate and world champion, Andrea Cassara, in the quarter-finals, 15-8, and Cheremisinov beat French world champion Enzo Lefort, 15-6. Russian world champion",
        mobileHtml: `
          <p>Italian world champion Alessio Foconi took the men’s individual foil gold medal at the 2019 H.I.H. Prince Takamado Trophy Men’s Foil World Cup in Tokyo, with France winning men’s team foil. </p>
          <p>The competition drew 211 men’s foilists and 19 teams from around the world. This World Cup, which was also an official Test Event for fencing, took place in the Makuhari Messe in Chiba City where fencing will be held at the 2020 Olympic Games. </p>
          <p>Foconi won the final match of the men’s individual foil event against France’s Maxime Pauty, 15-5. Pauty defeated Russian world champion Alexey Cheremisinov in the semi-final round, 15-10, while Foconi beat teammate and Olympic champion Daniele Garozzo, 15-10. Notably, Foconi overcame another teammate and world champion, Andrea Cassara, in the quarter-finals, 15-8, and Cheremisinov beat French world champion Enzo Lefort, 15-6. Russian world champion Dmitry Zherebchenko lost in the round of 16 to teammate Cheremisinov, 15-12. </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 36,
        subIndex: 0,
        startIndex: 0,
        original: "pg37.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/red-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/red-facebook.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/113/en/static/_content/red-trophy.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/113/en/static/_content/red-yt.png">
        </a>
        
        <img class="halfScale pointer 37-arrow" style="top:845px;left:1387px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/37-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>`,
        script: `
        function onPageEnter() {
          pg37Anim = new TimelineMax()
          pg37Anim
            .fromTo(cOf("37-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg37Anim.stop()
        }        
      `,
        searchText:
          "TOKYO MEN'S FOIL WORLD CUP AND OLYMPIC TEST EVENT TOKYO, JAPAN 3 OF 3  Dmitry Zherebchenko lost in the round of 16 to teammate Cheremisinov, 15-12. In men’s team foil, France scored the gold medal against USA, 45-39. The USA won against Russia in the semi-final, 45-34, and France overcame Italy, 45-27. The bronze medal went to Italy over Russia, 45-38. Final rankings for men’s individual foil included Alessio Foconi (ITA, gold), Maxime Pauty (FRA, silver), Alexey Cheremisinov (RUS, bronze), Daniele Garozzo (ITA, bronze), Enzo Lefort (FRA), Alexander Massialas (USA), Andrea Cassara (ITA) and Nick Itkin (USA). Ranking for men’s team foil included France (gold), USA (silver), Italy (bronze), Russia, Korea, Hong Kong, China and Japan. ■  Tap here to view the RESULTS  TAP HERE to link to our FIE YouTube series  W W W.FIE .ORG",
        mobileHtml: `
          <p>In men’s team foil, France scored the gold medal against USA, 45-39. The USA won against Russia in the semi-final, 45-34, and France overcame Italy, 45-27. The bronze medal went to Italy over Russia, 45-38.</p>
          <p><b>Final rankings for men’s individual foil included</b></p>
          <p>Alessio Foconi (ITA, gold)</p>
          <p>Maxime Pauty (FRA, silver)</p>
          <p>Alexey Cheremisinov (RUS, bronze)</p>
          <p>Daniele Garozzo (ITA, bronze)</p>
          <p>Enzo Lefort (FRA)</p>
          <p>Alexander Massialas (USA)</p>
          <p>Andrea Cassara (ITA)</p>
          <p>Nick Itkin (USA)</p>
          <p><b>Ranking for men’s team foil included</b></p>
          <p>France (gold)</p>
          <p>USA (silver)</p>
          <p>Italy (bronze)</p>
          <p>Russia, Korea, Hong Kong, China and Japan.</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 37,
        subIndex: 0,
        startIndex: 0,
        original: "pg38.jpg",
        zoom: null,
        content: `
        <div class="contentLink" style="bottom:193px;right:633px;width:180px; height:30px;">
          <a href="http://www.uhlmann-fencing.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:198px;right:844px;width:30px; height:30px;">
          <a href="https://www.facebook.com/uhlmann.fencing/" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:198px;right:813px;width:30px; height:30px;">
          <a href="http://www.instagram.com/Uhlmann.Fencing" target="_blank"></a>
        </div>
    `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
      
      <a href="http://www.uhlmann-fencing.com" target="_blank">
        <img src="/113/en/static/_mobile/pg38.jpg">
      </a>

      `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 38,
        subIndex: 0,
        startIndex: 0,
        original: "pg39.jpg",
        zoom: null,
        content: `
        <a href="mailto:sales@pbtfencing.com">
          <div class="contentLinkNone" style="top:1057px;left:66px;width:263px; height:28px;"></div>
        </a>

        <a href="http://www.pbtfencing.com" target="_blank">
          <div class="contentLinkNone" style="top:1057px;left:643px;width:249px; height:28px;"></div>
        </a>

        <a href="https://www.instagram.com/pbt_fencing/" target="_blank">
          <div class="contentLinkNone" style="top:1057px;left:1129px;width:343px; height:28px;"></div>
        </a>
      `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
      
      <a href="https://www.pbtfencing.com" target="_blank">
        <img src="/113/en/static/_mobile/pg39.jpg">
      </a>

      `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 39,
        subIndex: 0,
        startIndex: 0,
        original: "pg40.jpg",
        zoom: null,
        content: `
        <img class="halfScale 40-title" style="top:171px;left:84px" src="/113/en/static/_content/40-title.png">

        <img class="halfScale 40-line" style="top:460px;left:88px" src="/113/en/static/_content/40-line.png">

        <img class="halfScale 40-sub" style="top:461px;left:129px" src="/113/en/static/_content/40-sub.png">

       <img class="halfScale pointer 40-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/40-arrow.png">
       `,
        script: `
        function onPageEnter() {
          pg40Anim = new TimelineMax()
          pg40Anim.fromTo(cOf("40-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("40-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("40-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("40-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg40Anim.stop()
        }
      `,
        searchText:
          "INTERNATIONAL FENCING FEDER ATION ANNUAL C ONGRESS  2019 INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS IN LAUSANNE LAUSANNE, SWITZERLAND NOVEMBER 30, 2019",
        mobileHtml: `
          <h2>2019 International Fencing Federation Annual Congress in Lausanne </h2>
          <img src="/113/en/static/_mobile/pg40.jpg" >
          <p><strong>Lausanne, Switzerland<br>
          November 30, 2019</strong></p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 40,
        subIndex: 0,
        startIndex: 0,
        original: "pg41.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/gold-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/gold-facebook.png">
        </a>

        <a href="https://www.facebook.com/pg/fie.org/photos/?tab=album&album_id=2622989907748837&__tn__=-UC-R" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:812px;left:51px" src="/113/en/static/_content/41-gallery.png">
        </a>
        
        <img class="halfScale pointer 41-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/41-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg41Anim = new TimelineMax()
          pg41Anim
            .fromTo(cOf("41-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg41Anim.stop()
        }        
      `,
        searchText:
          "INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS LAUSANNE, SWITZERLAND 2 OF 4  After exactly 20 years, the Annual Congress of the International Fencing Federation (FIE) returned to the Olympic capital, with more than 300 delegates gathered in Lausanne, at the SwissTech Convention Center. The President of the International Fencing Federation, Mr. Alisher Usmanov, welcomed, at the opening of the Congress, Mr. Thomas Bach, President of the International Olympic Committee (IOC), who addressed the Congress and handed-over to Mr. Usmanov the IOC Trophy of Olympic Values. Mr. Bach greeted the members of the Executive Committee and delegates warmly, saying: “I am happy for the many achievements of fencing and how fencing is living the Olympic Values.” Mr. Bach went on to encourage delegates to “be a part of the change you want to see.”  Tap here to link through to GALLERY  AWARDS Challenge Chevalier Feyerick Every second (odd-numbered) year, the Challenge Chevalier Feyerick is awarded to an individual fencer team or group of fencers, or member federation that, during the last two years, has shown the most chivalrous and unselfish attitude and spirit of sportsmanship and Fair Play, serving as an example to others in the future.",
        mobileHtml: `
          <p>After exactly 20 years, the Annual Congress of the International Fencing Federation (FIE) returned to the Olympic capital, with more than 300 delegates gathered in Lausanne, at the SwissTech Convention Center.</p>
          <p>The President of the International Fencing Federation, Mr. Alisher Usmanov, welcomed, at the opening of the Congress, Mr. Thomas Bach, President of the International Olympic Committee (IOC), who addressed the Congress and handed-over to Mr. Usmanov the IOC Trophy of Olympic Values.</p>
          <p>Mr. Bach greeted the members of the Executive Committee and delegates warmly, saying: “I am happy for the many achievements of fencing and how fencing is living the Olympic Values.” Mr. Bach went on to encourage delegates to “be a part of the change you want to see.”</p>
          <h2>Awards </h2>
          <p><b>Challenge Chevalier Feyerick </b></p>
          <p>Every second (odd-numbered) year, the Challenge Chevalier Feyerick is awarded to an individual fencer team or group of fencers, or member federation that, during the last two years, has shown the most chivalrous and unselfish attitude and spirit of sportsmanship and Fair Play, serving as an example to others in the future.</p>
          <p>The Congress presented the 2019 Challenge Chevalier Feyerick to Mr. Thomas Bach.</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 41,
        subIndex: 0,
        startIndex: 0,
        original: "pg42.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/gold-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/gold-facebook.png">
        </a>

        <img class="halfScale pointer 42-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/42-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg42Anim = new TimelineMax()
          pg42Anim
            .fromTo(cOf("42-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg42Anim.stop()
        }  
      `,
        searchText:
          "INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS LAUSANNE, SWITZERLAND 3 OF 4  The Congress presented the 2019 Challenge Chevalier Feyerick to Mr. Thomas Bach. Fair Play Trophy Based on the proposal of the FIE Fair Play Council, the FIE Executive Committee awards the Fair Play trophy to one or several individuals in world fencing who exhibited a significant act of fair play during the year. For 2019, the award was given to the following fencers: • the Hungarian Men’s sabre team: Tamás Decsi, Csanád Gémesi, András Szatmári, Áron Szilágyi and; • Boladé Apithy (FRA)",
        mobileHtml: `
          <h2>Fair Play Trophy</h2>
          <p>Based on the proposal of the FIE Fair Play Council, the FIE Executive Committee awards the Fair Play trophy to one or several individuals in world fencing who exhibited a significant act of fair play during the year. For 2019, the award was given to the following fencers:</p>
          <p>The Hungarian Men’s sabre team:</p>
          <p>Tamás Decsi</p>
          <p>Csanád Gémesi</p>
          <p>András Szatmári</p>
          <p>Áron Szilágyi</p>
          <p>Boladé Apithy (FRA)</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 42,
        subIndex: 0,
        startIndex: 0,
        original: "pg43.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/gold-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/gold-facebook.png">
        </a>
        <img class="halfScale pointer 43-arrow" style="top:845px;left:1409px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/43-arrow.png">
        <img class="halfScaleC pointer halfpulse animatedpulse" onclick="showOverlay('43-overlay')"style="top:811px;left:55px" src="/113/en/static/_content/gold-earth.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <div id="43-overlay" class="standardTransition contentOverlay hidden noclick">
          <img id="" class="halfScale" style="top:0px;left:0px" src="/113/en/static/_content/43-overlay.png">
          <div class="contentLink" style="top: 85px; left: 1343px; width: 135px; height: 49px;opacity:0" onclick="hideOverlay('43-overlay');"></div>
        </div>

        `,
        script: `
        function onPageEnter() {
          pg43Anim = new TimelineMax()
          pg43Anim
            .fromTo(cOf("43-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg43Anim.stop()
          hideOverlay('43-overlay');
        }  
      `,
        searchText:
          "INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS LAUSANNE, SWITZERLAND 4 OF 4  NEW MEMBER FEDERATIONS The Congress approved the final affiliation of the following countries: • Cape Verde • Kenya • Oman • Papua New Guinea The number of members federations is now 157 worldwide  Tap here to view the WORLD RANKINGS  WORLD CHAMPIONSHIP HOSTS The Congress awarded to Egypt the organisation of the 2021 Senior Fencing World Championships. For the year 2022, a call for candidatures for all the championships was launched.  Furthermore, the Congress approved the report of the Executive Committee, the financial documents and the budget for the year 2020, an increase to 30 per cent of the representation of women in the FIE Commissions beginning with the 2020-2024 quadrennium, and the possibility for World and Olympic Champions to distinguish themselves by having their names printed on the backs of their fencing jackets, respectively, in red and gold. After the closing of the event, the International Fencing Family gathered for the Congress Dinner for delegates and guests including IOC President Thomas Bach at the Olympic Museum in Lausanne. ■  W W W.FIE .ORG",
        mobileHtml: `
          <h2>New Member Federations</h2>
          <p>The Congress approved the final affiliation 
          of the following countries:</p>
          <p>• Cape Verde </p>
          <p>• Kenya </p>
          <p>• Oman </p>
          <p>• Papua New Guinea </p>
          <p>The number of members federations is now 157 worldwide </p>
          <h2>World Championship Hosts</h2>
          <p>The Congress awarded to Egypt the organisation of the 2021 Senior Fencing World Championships. For the year 2022, a call for candidatures for all the championships 
          was launched.</p>
          <p>Furthermore, the Congress approved the report of the Executive Committee, the financial documents and the budget for the year 2020, an increase to 30 per cent of the representation of women in the FIE Commissions beginning with the 2020-2024 quadrennium, and the possibility for World and Olympic Champions to distinguish themselves by having their names printed on the backs of their fencing jackets, respectively, in red and gold.</p>
          <p>After the closing of the event, the International Fencing Family gathered for the Congress Dinner for delegates and guests including IOC President Thomas Bach at the Olympic Museum in Lausanne.</p>
          <p><b>RANKING WINNERS</b></p>
          <p>Each team and individual winner of the year’s top-level world junior and senior rankings in epee, foil and sabre as well as overall nations are awarded at the Congress. This year’s recipients of awards include the following:</p>
          <p><b>Epee</b></p>
          <p>Senior Team: <br>
          Russia (women) <br>
          Russia (men)</p>
          <p>Senior Individual: <br>
          Man Wai Vivian Kong (HKG) <br>
          Kazuyasu Minobe (JPN)</p>
          <p>Junior Team: <br>
          Russia (women) <br>
          Hungary (men)</p>
          <p>Junior Individual: <br>
          Federica Isola (ITA) <br>
          Davide Di Veroli (ITA)</p>
          <p><b>Foil</b></p>
          <p>Senior Team: <br>
          Russia (women) <br>
          USA (men)</p>
          <p>Senior Individual: <br>
          Inna Deriglazova (RUS) <br>
          Alessio Foconi (ITA)</p>
          <p>Junior Team:<br>
          Italy (women) <br>
          Russia (men)</p>
          <p>Junior Individual: <br>
          Martina Favaretto (ITA) <br>
          Mohamed Hamza (EGY)</p>
          <p><b>Sabre</b></p>
          <p>Senior Team: <br>
          France (women) <br>
          France (women) </p>
          <p>Senior Individual:<br>
          Olga Kharlan (UKR)
          Sanguk Oh (KOR)</p>
          <p>Junior Team:<br>
          Germany (women)
          Italy (men)</p>
          <p>Junior Individual:<br>
          Yoana Ilieva (BUL) <br>
          Lorenzo Roma (ITA)</p>
          <p><b>Nations Grand Prix</b></p>
          <p>Seniors: Russia <br>
          Juniors: Italy</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 43,
        subIndex: 0,
        startIndex: 0,
        original: "pg44.jpg",
        zoom: null,
        content: ``,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
        <img src="/113/en/static/_mobile/pg44.jpg">
        
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 44,
        subIndex: 0,
        startIndex: 0,
        original: "pg45.jpg",
        zoom: null,
        content: `
        <img class="halfScale pointer 45-arrow" style="top:949px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/45-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg45Anim = new TimelineMax()
          pg45Anim
            .fromTo(cOf("45-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg45Anim.stop()
        }  
      `,
        searchText: "MEE T THE ATHLE TES  			 RIO & SERA  			 AZUMA",
        mobileHtml: `
        <h2>7:1 Rio & Sera Azuma</h2>
        <img src="/113/en/static/_mobile/pg45.jpg" >
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 45,
        subIndex: 0,
        startIndex: 0,
        original: "pg46.jpg",
        zoom: null,
        content: `
      
        <img id="46-img-1" class="halfScale 46-questions" style="top:15px;left:16px; " src="/113/en/static/_content/46-img-1.jpg">
        <img id="46-img-2" class="halfScale 46-questions" style="top:17px;left:20px; display: none;" src="/113/en/static/_content/46-img-2.jpg">
        <img id="46-img-3" class="halfScale 46-questions" style="top:17px;left:20px; display: none;" src="/113/en/static/_content/46-img-3.jpg">
        <img id="46-img-4" class="halfScale 46-questions" style="top:17px;left:20px; display: none;" src="/113/en/static/_content/46-img-4.jpg">
        <img id="46-img-5" class="halfScale 46-questions" style="top:17px;left:20px; display: none;" src="/113/en/static/_content/46-img-5.jpg">
        <img id="46-img-6" class="halfScale 46-questions" style="top:17px;left:20px; display: none;" src="/113/en/static/_content/46-img-6.jpg">
        <img id="46-img-7" class="halfScale 46-questions" style="top:17px;left:20px; display: none;" src="/113/en/static/_content/46-img-7.jpg">

        <img id="46-no-1" class="halfScale 46-questions" style="top:412px;left:714.5px"; src="/113/en/static/_content/46-1.png">
        <img id="46-no-2" class="halfScale 46-questions" style="top:417px;left:728px;  display: none;" src="/113/en/static/_content/46-2.png">
        <img id="46-no-3" class="halfScale 46-questions" style="top:417px;left:728px; display: none; " src="/113/en/static/_content/46-3.png">
        <img id="46-no-4" class="halfScale 46-questions" style="top:417px;left:728px; display: none;" src="/113/en/static/_content/46-4.png">
        <img id="46-no-5" class="halfScale 46-questions" style="top:417px;left:728px; display: none;" src="/113/en/static/_content/46-5.png">
        <img id="46-no-6" class="halfScale 46-questions" style="top:417px;left:728px; display: none;" src="/113/en/static/_content/46-6.png">
        <img id="46-no-7" class="halfScale 46-questions" style="top:417px;left:728.5px; display: none;" src="/113/en/static/_content/46-7.png">
        
        <div class="addContentLink" style="top: 443px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('46-no-1', '46-img-1')"></div>
        <div class="addContentLink" style="top: 538px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('46-no-2', '46-img-2')"></div>
        <div class="addContentLink" style="top: 629px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('46-no-3', '46-img-3')"></div>
        <div class="addContentLink" style="top: 722px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('46-no-4', '46-img-4')"></div>
        <div class="addContentLink" style="top: 813px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('46-no-5', '46-img-5')"></div>
        <div class="addContentLink" style="top: 907px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('46-no-6', '46-img-6')"></div>
        <div class="addContentLink" style="top: 1000px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('46-no-7', '46-img-7')"></div>

        <img id="46-next" class="halfScale pointer" style="top:949px;left:651px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/46-arrow.png">
      `,
        script: `
        function onPageEnter() {
          pg46Anim = new TimelineMax()
          pg46Anim.fromTo(idOf("46-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }
  
        function swapQuestion(ele, img) {
          var x = cOf("46-questions");
          var i;
          for (i = 0; i < x.length; i++) {
            x[i].style.display = 'none';
          }
          idOf(ele).style.display = ""
          idOf(img).style.display = ""
        }
  
        function onPageLeave() {
          pg46Anim.stop()
          removeContentLinks()
        }
      `,
        searchText:
          "Japan’s Azuma sisters, Rio (21) and Sera (20), are both competitive fencers active on the international women’s foil circuit. They became interested in fencing because of their mother, who represented Japan in the Junior and Cadet Fencing World Championships. Home from the recent Saint Maur Women’s Foil World Cup in France, the pair shared their fencing experiences with us. How is it to compete as sisters? RIO: Nothing special to me. I play just to win. SERA: Being with Rio is very reassuring, but, when fencing with her, of course, I try to do my best to win. However, as we know everything about each other, it is actually very tough to play with her.  1 2 3 4 5 6 7",
        mobileHtml: `
          <p>Japan’s Azuma sisters, Rio (21) and Sera (20), are both competitive fencers active on the international women’s foil circuit. They became interested in fencing because of their mother, who represented Japan in the Junior and Cadet Fencing World Championships. Home from the recent Saint Maur Women’s Foil World Cup in France, the pair shared their fencing experiences with us.</>
          <p><b>How is it to compete as sisters?</b></p>
          <p>Rio: Nothing special to me. I play just to win.</p>
          <p>Sera: Being with Rio is very reassuring, but, when fencing with her, of course, I try to do my best to win. However, as we know everything about each other, it is actually very tough to play with her. </p>
          <p><b>What was it like when you began competing internationally?</b><p/>
          <p>Rio: I was a little bit afraid of playing with foreign fencers, as I just didn’t have any experience.</p>
          <p>Sera: I used to feel foreign fencers were very strong and they cried in a very loud voice quite often!</p>
          <p><b>What are your goals for fencing, for each of you?</b></p>
          <p>Rio: We will attend the Olympic Games together. </p>
          <p>Sera: Sera: To get a gold medal in the Olympic Games.</p>
          <p><b>What have been your best fencing experiences?</b></p>
          <p>Rio: Playing with foreign fencers is wonderful, an experience I never thought of. </p>
          <p>Sera: I got my first silver medal in a senior FIE World Cup last year (in Algeria), which was a wonderful experience, and hard to believe it at that moment.</p>
          <p><b>What do you love most about fencing?</b></p>
          <p>Rio: When I have won a game!</p>
          <p>Sera: The feeling when winning. I feel very happy when efforts finally bear fruit.</p>
          <p><b>What does it mean to you for the Olympic Games to be in Tokyo in 2020?</b></p>
          <p>Rio: To attend the Olympic Games held in my country should be a lot of value for me and affect my life.</p>
          <p>Sera: Just special, regardless of the results.</p>
          <p><b>What message do you have for younger fencers around the world?</b></p>
          <p>Rio & Sera (both): We are preparing very hard to get medals at the Olympic Games. We will work continuously very hard for the people who support us. Please cheer us on!</p>

          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 46,
        subIndex: 0,
        startIndex: 0,
        original: "pg47.jpg",
        zoom: null,
        content: ``,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
        <img src="/113/en/static/_mobile/pg47.jpg">
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 47,
        subIndex: 0,
        startIndex: 0,
        original: "pg48.jpg",
        zoom: null,
        content: `
        <img class="halfScale 48-title" style="top:828px;left:79px" src="/113/en/static/_content/48-title.png">

        <img class="halfScale 48-line" style="top:1005px;left:704px" src="/113/en/static/_content/48-line.png">

        <img class="halfScale 48-sub" style="top:994px;left:725px" src="/113/en/static/_content/48-sub.png">

       <img class="halfScale pointer 48-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/48-arrow.png">
       `,
        script: `
        function onPageEnter() {
          pg48Anim = new TimelineMax()
          pg48Anim.fromTo(cOf("48-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("48-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("48-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("48-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg48Anim.stop()
        }
      `,
        searchText:
          "¬ FIE & NATIONAL FEDER ATION NE WS  FIE CONTEST SEEKS NEW SABRE TECHNOLOGY  LAUSANNE, SWITZERLAND NOVEMBER 25, 2019",
        mobileHtml: `
          <h2>FIE contest seeks new sabre technology</h2>
          <img src="/113/en/static/_mobile/pg48.jpg" >
          <p><b>Lausanne, Switzerland<br>
          November 25, 2019</b></p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 48,
        subIndex: 0,
        startIndex: 0,
        original: "pg49.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/green-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/green-facebook.png">
        </a>

        <img class="halfScale pointer 49-arrow" style="top:845px;left:1387px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/49-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <a href="https://static.fie.org/uploads/23/118870-ED%2019%E2%80%9D%20Contest%20-%20Regulations%20ENG%20FINALE%20%28%20R-T%29%2018.11.2019.pdf " target="_blank">
          <div class="contentLinkNone" style="bottom:199px;right:315px;width:219px; height:30px;"></div>
        </a>
        <a href="https://static.fie.org/uploads/23/118876-Initial%20Request%20for%20%E2%80%9CED-19%E2%80%9D%20Contest%20Participation%20Form%20Tsukhlo%20LAST.pdf " target="_blank">
          <div class="contentLinkNone" style="bottom:139px;right:239px;width:295px; height:30px;"></div>
        </a>

        
        `,
        script: `
        function onPageEnter() {
          pg49Anim = new TimelineMax()
          pg49Anim.fromTo(cOf("49-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg49Anim.stop()
        }
      `,
        searchText:
          "FIE & NATIONAL FEDERATION NEWS 2 OF 2  The FIE is sponsoring an international contest inviting developers to create new technology for registering hits in sabre fencing. The objective is to design and manufacture a modern sensor, one that is easy to use, inexpensive and durable for competition. An FIE Contest Commission that includes members of the Executive Committee and several commissions and councils, as well sport/ technical staff, is responsible for accepting and appraising sensor prototypes.  There are specific requirements for the design. According to FIE Sport and Technical Director Evgeny Tsoukhlo, “The apparatus should not register light touches or blade contact, but rather only valid hits of the blade on an opponent”. He added, “Overall, the technology must meet the standards of sabre fencing, including both thrusting and cutting touches with the cutting edge and back of the blade. All hits made with the cutting edge, flat or back of the blade should register as valid touches. Hits with the guard are not allowed, must be annulled and the fencer making the hit is penalised. Hits made ‘through’ the blade must score as valid, meaning those that touch both the opponent’s sabre and a valid target area simultaneously.” The two accompanying documents include specific and technical details and rules of the contest, as well as a request for participation.■ Click here for Contest regulations Click here for Contest participation form  W W W.FIE .ORG",
        mobileHtml: `
          <p>The FIE is sponsoring an international contest inviting developers to create new technology for registering hits in sabre fencing. </p>
          <p>The objective is to design and manufacture a modern sensor, one that is easy to use, inexpensive and durable for competition. An FIE Contest Commission that includes members of the Executive Committee and several commissions and councils, as well sport/technical staff, is responsible for accepting and appraising sensor prototypes.</p>
          <p>There are specific requirements for the design. According to FIE Sport and Technical Director Evgeny Tsoukhlo, “The apparatus should not register light touches or blade contact, but rather only valid hits of the blade on an opponent”. He added, “Overall, the technology must meet the standards of sabre fencing, including both thrusting and cutting touches with the cutting edge and back of the blade. All hits made with the cutting edge, flat or back of the blade should register as valid touches. Hits with the guard are not allowed, must be annulled and the fencer making the hit is penalised. Hits made ‘through’ the blade must score as valid, meaning those that touch both the opponent’s sabre and a valid target area simultaneously.”</p>
          <p>The two accompanying documents include specific and technical details and rules of the contest, as well as a request for participation.</p>
          <a href="" target="_blank">Click here for Contest regulations</a> <br>
          <a href="" target="_blank">Click here for Contest participation form</a>

          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 49,
        subIndex: 0,
        startIndex: 0,
        original: "pg50.jpg",
        zoom: null,
        content: `
        <img class="halfScale 50-title" style="top:85px;left:93px" src="/113/en/static/_content/50-title.png">

        <img class="halfScale 50-line" style="top:261px;left:715px" src="/113/en/static/_content/50-line.png">

        <img class="halfScale 50-sub" style="top:260px;left:754px" src="/113/en/static/_content/50-sub.png">

       <img class="halfScale pointer 50-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/50-arrow.png">
       `,
        script: `
        function onPageEnter() {
          pg50Anim = new TimelineMax()
          pg50Anim.fromTo(cOf("50-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("50-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("50-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("50-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg50Anim.stop()
        }
      `,
        searchText:
          "¬ FIE & NATIONAL FEDER ATION NE WS  BUDAPEST COACHING ACADEMY OPEN FOR ENROLLMENT  LAUSANNE, SWITZERLAND DECEMBER 5, 2019",
        mobileHtml: `
          <h2>Budapest Coaching Academy Open for Enrollment</h2>
          <img src="/113/en/static/_mobile/pg50.jpg" >
          <p><b>Budapest, Hungary<br>
          December 5, 2019</p></b>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 50,
        subIndex: 0,
        startIndex: 0,
        original: "pg51.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/green-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/green-facebook.png">
        </a>

        <img class="halfScale pointer 51-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/51-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg51Anim = new TimelineMax()
          pg51Anim.fromTo(cOf("51-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg51Anim.stop()
        }
      `,
        searchText:
          "FIE & NATIONAL FEDERATION NEWS 2 OF 3  As part of the FIE development programme and ongoing commitment to expanding and enriching fencing around the world, the FIE is sponsoring the 2020 Budapest Coaching Academy. The program, open to coaches in FIE-affiliated member federations from Europe, the Americas and Asia/Oceania, includes a set of threemonth sessions—one for each weapon (epee, foil, sabre)—held throughout the year. Graduates of the program will receive an official FIE-recognised diploma.  The Budapest Coaching Academy curriculum includes classes in psychology, physiology, sport theory and biomechanics in addition to coaching education and fencing practice. Each of the three-month programs will be held in English and take place with a full-time, daily (Monday-Friday) schedule. The format of the",
        mobileHtml: `
          <p>As part of the FIE development programme and ongoing commitment to expanding and enriching fencing around the world, the FIE is sponsoring the 2020 Budapest Coaching Academy</p>
          <p>The program, open to coaches in FIE-affiliated member federations from Europe, the Americas and Asia/Oceania, includes a set of three-month sessions—one for each weapon (epee, foil, sabre)—held throughout the year. Graduates of the program will receive an official FIE-recognised diploma.</p>
          <p>The Budapest Coaching Academy curriculum includes classes in psychology, physiology, sport theory and biomechanics in addition to coaching education and fencing practice. Each 
          of the three-month programs will be held in English and take place with a full-time, daily (Monday-Friday) schedule. The format of the program is open to eight students per weapon, including six from Europe and two from the Americas and Asia/Oceania.</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 51,
        subIndex: 0,
        startIndex: 0,
        original: "pg52.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/green-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/green-facebook.png">
        </a>

        <img class="halfScale pointer 52-arrow" style="top:845px;left:1386px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/52-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <a href="mailto:training.camp@fie.ch" target="_blank">
          <div class="contentLinkNone" style="bottom:142px;right:489px;width:197px; height:30px;"></div>
        </a>
        

        
        `,
        script: `
        function onPageEnter() {
          pg52Anim = new TimelineMax()
          pg52Anim.fromTo(cOf("52-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("52-line"), 0.6, {y:52, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("52-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("52-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg52Anim.stop()
        }
      `,
        searchText:
          "FIE & NATIONAL FEDERATION NEWS 3 OF 3  program is open to eight students per weapon, including six from Europe and two from the Americas and Asia/Oceania. “The FIE is dedicated to strengthening our sport as well as the effectiveness and availability of coaching”, said Evgeny Tsukhlo, FIE Sport and Technical Director. “This is one of many ways in which we are engaged in supporting our members and their efforts to continually develop fencing.” Eligible applicants to the program must meet certain requirements, notably including having at least seven years of coaching experience, a level-three coaching diploma, an FIE or national fencing license and a commitment to coaching in their national federation for a minimum of two years after graduation. Also required is written approval from each applicant’s national federation president, a biography, and other details. ■  Following is the schedule for the Academy sessions:  Epee: January 20 to April 18; application deadline has passed  Sabre: April 22 to July 20; application deadline is February 14, 2020  Foil: September 17 to December 15; application deadline is June 12, 2020 Applications must be sent from the national federations to the FIE to: training.camp@fie.ch.  W W W.FIE .ORG",
        mobileHtml: `
          <p>“The FIE is dedicated to strengthening our sport as well as the effectiveness and availability of coaching”, said Evgeny Tsukhlo, FIE Sport and Technical Director. “This is one of many ways in which we are engaged in supporting our members and their efforts to continually develop fencing.”</p>
          <p>Eligible applicants to the program must meet certain requirements, notably including having at least seven years of coaching experience, a level-three coaching diploma, an FIE or national fencing license and a commitment to coaching in their national federation for a minimum of two years after graduation. Also required is written approval from each applicant’s national federation president, a biography, and other details.</p>
          <p><b>Following is the schedule for the Academy sessions:</b></p>
          <p>Epee: January 20 to April 18; application deadline has passed</p>
          <p>Sabre: April 22 to July 20; application deadline is February 14, 2020</p>
          <p>Foil: September 17 to December 15; application deadline is June 12, 2020</p>
          <p>Applications must be sent from the national federations to the FIE to: training.camp@fie.ch.</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 52,
        subIndex: 0,
        startIndex: 0,
        original: "pg53.jpg",
        zoom: null,
        content: `
        <a href="https://www.fencewithfun.com" target="_blank">
            <div class="contentLinkNone" style="top:769px;left:18px;width:614px; height:43px;"></div>
          </a>

          <a href="mailto:info@fencewithfun.com">
            <div class="contentLinkNone" style="top:940px;left:75px;width:219px; height:28px;"></div>
          </a>

          <a href="https://www.fencewithfun.com" target="_blank">
            <div class="contentLinkNone" style="top:942px;left:353px;width:214px; height:28px;"></div>
          </a>
          `,
        script: ``,
        searchText: "",
        mobileHtml: `
      
      <a href="https://www.fencewithfun.com" target="_blank">
        <img src="/113/en/static/_mobile/pg53.jpg">
      </a>
        `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 53,
        subIndex: 0,
        startIndex: 0,
        original: "pg54.jpg",
        zoom: null,
        content: `
        <img class="halfScale 54-title" style="top:93px;left:81px" src="/113/en/static/_content/54-title.png">

        <img class="halfScale 54-line" style="top:363px;left:85px" src="/113/en/static/_content/54-line.png">

        <img class="halfScale 54-sub" style="top:363px;left:122px" src="/113/en/static/_content/54-sub.png">

       <img class="halfScale pointer 54-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/54-arrow.png">
       `,
        script: `
        function onPageEnter() {
          pg54Anim = new TimelineMax()
          pg54Anim.fromTo(cOf("54-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("54-line"), 0.6, {y:54, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("54-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("54-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg54Anim.stop()
        }
      `,
        searchText:
          "¬ FIE & NATIONAL FEDER ATION NE WS  DEMOS AND COMPETITIONS HELD IN TOKYO TOKYO, JAPAN DECEMBER 11, 2019",
        mobileHtml: `
          <h2>Demos and competitions held in Tokyo</h2>
          <img src="/113/en/static/_mobile/pg54.jpg" >
          <p><b>Tokyo, Japan<br>
          December 11, 2019</b></p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 54,
        subIndex: 0,
        startIndex: 0,
        original: "pg55.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/green-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/green-facebook.png">
        </a>

        <img class="halfScale pointer 55-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/55-arrow.png">

        <a href="https://www.facebook.com/pg/fie.org/photos/?tab=album&album_id=2642671112447383&__tn__=-UC-R" target="_blank">
            <div class="contentLinkNone" style="top:980px;left:1233px;width:58px; height:30px;"></div>
          </a>
      `,
        script: `
        function onPageEnter() {
          pg55Anim = new TimelineMax()
          pg55Anim.fromTo(cOf("55-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg55Anim.stop()
        }
      `,
        searchText:
          "FIE & NATIONAL FEDERATION NEWS 2 OF 4  The International Fencing Federation held interactive fencing exhibitions for schoolchildren in Japan as it prepares for the 2020 Tokyo Summer Olympic Games. The events took place prior to the December 13-15 Tokyo Senior Men’s Foil World Cup/ Olympic Test Event. On Sunday, December 8, a fencing demo at the Bunkyo Sports Center gave children the opportunity to try fencing with a coach and promoted the upcoming World Cup/Test Event  and 2020 Olympic Games. Several thousand students from elementary schools around Tokyo’s Bunkyo City were invited, and many schoolchildren who attended were able to experience fencing first-hand. Souvenirs and recognition were given for taking part, along with photos and opportunities to meet athletes. Photos from the event may be viewed here.",
        mobileHtml: `
          <p>The International Fencing Federation held interactive fencing exhibitions for schoolchildren in Japan as it prepares for the 2020 Tokyo Summer Olympic Games</p>
          <p>The events took place prior to the December 13-15 Tokyo Senior Men’s Foil World Cup/Olympic Test Event.</p>
          <p>On Sunday, December 8, a fencing demo at the Bunkyo Sports Center gave children the opportunity to try fencing with a coach and promoted the upcoming World Cup/Test Event and 2020 Olympic Games. Several thousand students from elementary schools around Tokyo’s Bunkyo City were invited, and many schoolchildren who attended were able to experience fencing first-hand. Souvenirs and recognition were given for taking part, along with photos and opportunities to meet athletes. Photos from the event may be viewed 
          <a href="" target="_blank">here.</a></p>
          
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 55,
        subIndex: 0,
        startIndex: 0,
        original: "pg56.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/green-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/green-facebook.png">
        </a>

        <svg class="abs pulse animatedpulse pointer" onclick="Publish.openVideo('https://www.youtube.com/embed/soUTTfv1McQ')" style="bottom:278px;left:933px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
          <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
        </svg>
        <svg class="abs pulse animatedpulse pointer" onclick="Publish.openVideo('https://www.youtube.com/embed/e71jp4xauJA')" style="bottom:278px;left:1184px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
          <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
        </svg>

        <img class="halfScale pointer 56-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/56-arrow.png">
        `,
        script: `
        function onPageEnter() {
          pg56Anim = new TimelineMax()
          pg56Anim.fromTo(cOf("56-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg56Anim.stop()
        }
      `,
        searchText:
          "FIE & NATIONAL FEDERATION NEWS 3 OF 4  “Today we had children learn about fencing,” said Sato. “They learned about the three weapons, how to cheer in the competition, and how to celebrate winning points and support the athletes. I would love for Japan to be represented at the Olympics in every weapon in both team and individual events. With the Olympics in Japan, now my family and other Japanese people can directly watch a fencing competition, and we would love to have them come and watch it live!”  CLICK TO WATCH  FENCING INITIATION #roadtoTokyo  FENCING IN THE SCHOOLS / #roadtoTokyo",
        mobileHtml: `
          <p>On December 10, Japanese Olympic fencer Nozomi Sato, who competed in epee at the Rio and London Olympic Games, joined fencers Ikuo Furuta and Seiya Matsuura to present about 400 students with an introduction to fencing at the Sakuradai Elementary School in Chiba.</p>
          <p>“Today we had children learn about fencing,” said Sato. “They learned about the three weapons, how to cheer in the competition, and how to celebrate winning points and support the athletes. I would love for Japan to be represented at the Olympics in every weapon in both team and individual events. With the Olympics in Japan, now my family and other Japanese people can directly watch a fencing competition, and we would love to have them come and watch it live!”</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 56,
        subIndex: 0,
        startIndex: 0,
        original: "pg57.jpg",
        zoom: null,
        content: `<a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/green-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/green-facebook.png">
        </a>

        <img class="halfScale pointer 57-arrow" style="top:845px;left:1386px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/57-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <a href="https://fie.org/competitions/2020/137" target="_blank">
          <div class="contentLinkNone" style="top:429px;left:643px;width:131px; height:30px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg57Anim = new TimelineMax()
          pg57Anim.fromTo(cOf("57-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg57Anim.stop()
        }
      `,
        searchText:
          "FIE & NATIONAL FEDERATION NEWS 4 OF 4  The Senior Men’s Foil World Cup, held at the Makuhari Messe in Chiba where fencing will take place at the Olympic Games, serves as the official Tokyo 2020 Test Event for fencing. More than 200 international men’s foil fencers participated. More information about the World Cup/Test Event may be found here on the FIE web site. ■  W W W.FIE .ORG",
        mobileHtml: `
          <p>The Senior Men’s Foil World Cup, held at the Makuhari Messe in Chiba where fencing will take place at the Olympic Games, serves as the official Tokyo 2020 Test Event for 
          fencing. More than 200 international men’s foil fencers participated. </p>
          <p>More information about the World Cup/Test Event may be found here on the FIE web site.</p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 57,
        subIndex: 0,
        startIndex: 0,
        original: "pg58.jpg",
        zoom: null,
        content: `
        <img class="halfScale 58-title" style="top:128px;left:781px" src="/113/en/static/_content/58-title.png">

        <img class="halfScale 58-line" style="top:404px;left:785px" src="/113/en/static/_content/58-line.png">

        <img class="halfScale 58-sub" style="top:401px;left:822px" src="/113/en/static/_content/58-sub.png">

       <img class="halfScale pointer 58-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/58-arrow.png">
       `,
        script: `
        function onPageEnter() {
          pg58Anim = new TimelineMax()
          pg58Anim.fromTo(cOf("58-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("58-line"), 0.6, {y:58, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("58-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("58-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg58Anim.stop()
        }
      `,
        searchText:
          "¬ FIE & NATIONAL FEDER ATION NE WS  ETROPOLSKI EUROPEAN SABRE CUP SOFIA, BULGARIA NOVEMBER 15-17, 2019",
        mobileHtml: `
          <h2>Etropolski European Sabre Cup</h2>
          <img src="/113/en/static/_mobile/pg58.jpg" >
          <p><b>Sofia, Bulgaria<br>
          November 15-17, 2019</b></p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 58,
        subIndex: 0,
        startIndex: 0,
        original: "pg59.jpg",
        zoom: null,
        content: `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/113/en/static/_content/green-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/113/en/static/_content/green-facebook.png">
        </a>
        
          <img class="halfScaleC pointer halfpulse animatedpulse" onclick="showOverlay('59-overlay')" style="top:879px;left:61px" src="/113/en/static/_content/green-trophy.png">
        
        <img class="halfScale pointer 59-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/59-arrow.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <div id="59-overlay" class="standardTransition contentOverlay hidden noclick">
          <img id="" class="halfScale" style="top:0px;left:0px" src="/113/en/static/_content/59-overlay.png">
          <div class="contentLink" style="top: 85px; left: 1343px; width: 135px; height: 49px;opacity:0" onclick="hideOverlay('59-overlay');"></div>
        </div>
        
        `,
        script: `
        function onPageEnter() {
          pg59Anim = new TimelineMax()
          pg59Anim.fromTo(cOf("59-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg59Anim.stop()
          hideOverlay('59-overlay');
        }
      `,
        searchText:
          "FIE & NATIONAL FEDERATION NEWS 2 OF 2  More than 500 fencers from 28 countries competed at the Etropolski Sabre European Cup in Sofia, Bulgaria, including both team and individual events. The competition took place at Sofia’s Asics Arena.  Tap here to see the RESULTS  The first day, November 15, included boys and girls under 14, with the individual sabre gold going to Arda Mustafa Gundogar (TUR) and Emese Domonkos (HUN). The second day featured individual cadet men’s sabre and team cadet women’s sabre, with Todor Stoychev (BUL) taking the gold for the men and Team USA winning for the girls. On the final day, Zoe Kim (USA) won the gold medal in individual cadet women’s sabre, while Team Bulgaria won team cadet men’s sabre. ■  W W W.FIE .ORG",
        mobileHtml: `
          <p>More than 500 fencers from 28 countries competed at the Etropolski Sabre European Cup in Sofia, Bulgaria, including both team and individual events. The competition took place at Sofia’s Asics Arena.</p>
          <p>The first day, November 15, included boys and girls under 14, with the individual sabre gold going to Arda Mustafa Gundogar (TUR) and Emese Domonkos (HUN). The second day featured individual cadet men’s sabre and team cadet women’s sabre, with Todor Stoychev (BUL) taking the gold for the men and Team USA winning for the girls. On the final day, Zoe Kim (USA) won the gold medal in individual cadet women’s sabre, while Team Bulgaria won team cadet men’s sabre.</p>
          <p><b>Overall results included the following:</b></p>
          <p><b>Individual Under-14 Boy’s Sabre: </b><br>
          Arda Mustafa Gundogar (TUR, gold) <br>
          Demir Cilingir (TUR, silver) <br>
          Enache Dacian (ROM, bronze) <br>
          Matyas Farkas (HUN, bronze)</p>
          <p><b>Individual Under-14 Girl’s Sabre: </b><br>
          Emese Domonkos (HUN, gold) <br>
          Zarifa Huseynova (AZE, silver) <br>
          Kalina Atanasova (BUL, bronze) <br>
          Damla Demirkol (TUR, bronze)</p>
          <p><b>Individual Cadet Men’s Sabre: </b><br>
          Todor Stoychev (BUL, gold) <br>
          Kirk Chayevsky (USA, silver) <br>
          Colby Harley (USA, bronze) <br>
          Oleksander Kushkov (USA, bronze)</p>
          <p><b>Individual Cadet Women’s Sabre: </b><br>
          Zoe Kim (USA, gold) <br>
          Alina Korolova (RUS, silver) <br>
          Nithya Guthikonda (USA, bronze) <br>
          Zsanett Kocacs (HUN, bronze)</p>
          <p><b>Team Cadet Men’s Sabre: </b><br>
          Bulgaria (gold)) <br>
          Hungary (silver) <br>
          Hungary (silver)<br></p>
          <p><b>Team Cadet Women’s Sabre: </b><br>
          USA (gold) <br>
          Ukraine (silver) <br>
          USA (bronze)<br> </p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 59,
        subIndex: 0,
        startIndex: 0,
        original: "pg60.jpg",
        zoom: null,
        content: `
        <a href="https://absolutefencinggear.com" target="_blank">
            <div class="contentLinkNone" style="top:1022px;left:372px;width:484px; height:47px;"></div>
          </a>
          `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
        <a href="https://absolutefencinggear.com" target="_blank">
          <img src="/113/en/static/_mobile/pg60.jpg">
        </a>
      `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 60,
        subIndex: 0,
        startIndex: 0,
        original: "pg61.jpg",
        zoom: null,
        content: `
        <a href="http://www.gfencing.com" target="_blank">
            <div class="contentLinkNone" style="top:728px;left:545px;width:219px; height:28px;"></div>
          </a>

          <a href="mailto:sales@gfencing.com">
            <div class="contentLinkNone" style="top:728px;left:765px;width:219px; height:28px;"></div>
          </a>
          `,
        script: `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
        searchText: "",
        mobileHtml: `
        <a href="https://www.gfencing.com" target="_blank">
          <img src="/113/en/static/_mobile/pg61.jpg">
        </a>
      `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 61,
        subIndex: 0,
        startIndex: 0,
        original: "pg62.jpg",
        zoom: null,
        content: `
        <img class="halfScale 62-title" style="top:75px;left:84px" src="/113/en/static/_content/62-title.png">

        <img class="halfScale pointer 62-arrow" style="top:938px;left:1174px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/62-arrow.png">
        
        <a href="https://video.eurosport.com/fencing/sofya-velikaya-fencing-is-my-miracle_vid1267642/video.shtml" target="_blank">
          <svg class="abs pulse animatedpulse pointer"  style="bottom:642px;left:1351px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
            <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>
        <a href="https://video.eurosport.com/fencing/60-second-pro-race-imboden-gives-insight-into-what-makes-a-world-class-fencer_vid1273346/video.shtml " target="_blank">
          <svg class="abs pulse animatedpulse pointer"  style="bottom:476px;left:1351px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
            <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>
        <a href="https://video.eurosport.com/fencing/fencing-generation-inside-the-aspire-academy-in-qatar_vid1272523/video.shtml" target="_blank">
          <svg class="abs pulse animatedpulse pointer"  style="bottom:279px;left:588px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
            <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>
        <a href="https://video.eurosport.co.uk/fencing/face-2-face-two-time-world-champion-sofia-pozdniakova-looks-back-at-her-career_vid1270170/video.shtml" target="_blank">
          <svg class="abs pulse animatedpulse pointer"  style="bottom:124px;left:408px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
            <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>
        <a href="https://video.eurosport.com/fencing/i-fight-with-a-bushido-mindset-kazuyasu-minobe-on-the-noble-sport-of-fencing_vid1258763/video.shtml" target="_blank">
          <svg class="abs pulse animatedpulse pointer"  style="bottom:550px;left:154px;" width="80.4px" height="77.4px" viewBox="0 0 69.4 67.4">
            <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        `,
        script: `
        function onPageEnter() {
          pg62Anim = new TimelineMax()
          pg62Anim.fromTo(cOf("62-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("62-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg62Anim.stop()
        }
      `,
        searchText:
          "EUROSP ORT VLO G  FENCING AROUND THE WORLD Sofya Velikaya: Fencing is my miracle  ‘I fight with a Bushido mindset’ Kazuyasu Minobe on the noble sport of fencing  Tap to play  Face-2-Face: Two-time world champion Sofia Pozdniakova looks back at her career  60 Second Pro: Race Imboden on what makes a world-class fencer  Fencing Generation: Inside the Aspire Academy in Qatar  W W W.FIE .ORG",
        mobileHtml: `
          <h2>Fencing around the world</h2>
          <p>‘I fight with a Bushido mindset’ 
          Kazuyasu Minobe on the noble sport of fencing.</p>
          <p><a href="https://video.eurosport.com/fencing/i-fight-with-a-bushido-mindset-kazuyasu-minobe-on-the-noble-sport-of-fencing_vid1258763/video.shtml" target="_blank" >Tap to play</a></p>
          <p><b>Face-2-Face:</b></p>
          <p>Two-time world champion Sofia Pozdniakova looks back at her career</p>
          <p><a href="https://video.eurosport.co.uk/fencing/face-2-face-two-time-world-champion-sofia-pozdniakova-looks-back-at-her-career_vid1270170/video.shtml" target="_blank" >Tap to play</a></p>
          <p><b>Fencing Generation:</b></p>
          <p>Inside the Aspire Academy in Qatar</p>
          <p><a href="https://video.eurosport.com/fencing/fencing-generation-inside-the-aspire-academy-in-qatar_vid1272523/video.shtml" target="_blank" >Tap to play</a></p>
          <p><b>Sofya Velikaya: </b></p>
          <p>Fencing is my miracle</p>
          <p><a href="https://video.eurosport.com/fencing/sofya-velikaya-fencing-is-my-miracle_vid1267642/video.shtml" target="_blank" >Tap to play</a></p>
          <p><b>60 Second Pro: </b></p>
          <p>Race Imboden on what makes a world-class fencer</p>
          <p><a href="https://video.eurosport.com/fencing/60-second-pro-race-imboden-gives-insight-into-what-makes-a-world-class-fencer_vid1273346/video.shtml" target="_blank" >Tap to play</a></p>
          `
      }
    ],
    [
      {
        guid: "00000000-0000-0000-0000-000000000000",
        title: "",
        index: 62,
        subIndex: 0,
        startIndex: 0,
        original: "pg63.jpg",
        zoom: null,
        content: `
        <img id="63-title" class="halfScale" style="top:81px;left:80px" src="/113/en/static/_content/63-title.png">

        <img class="halfScale pointer 63-arrow" style="top:845px;left:1251px" onclick="Publish.goToNextPage()" src="/113/en/static/_content/63-arrow.png">
        `,
        script: ` 
        function onPageEnter() {
        pg63Anim = new TimelineMax();
        pg63Anim.fromTo(idOf("63-title"), 0.5,{y:-100,opacity:0}, {y:0,opacity:1}, 1)
        .fromTo(cOf("63-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1.5)
        }
        function onPageLeave() {
        pg63Anim.stop()
        }
        `,
        searchText: "",
        mobileHtml: `
        <p><b>COLONEL ALBERT KAYA (CGO)</b></p>
        <p>The FIE is saddened to be informed of the passing of Colonel Albert Kaya, president of the Congolese Fencing Federation, on January 19 at the Centre Hospitalier Universitaire de Brazzaville.</p>
        <p>On behalf of our world fencing family, we extend our deepest sympathy and condolences to Colonel Kaya’s family and friends, the Congolese Fencing Federation and the African Fencing Confederation during this difficult period.■</p>
        `
      }
    ]
  ],
  script: `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
  mobilePages: [
    {
      title: "Escrime XXI No. 113",
      cssClass: "cover mobile-p1",
      hideInMenu: false,
      pageLinks: [
        {
          index: 0,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 2,
          subIndex: 0
        }
      ]
    },

    {
      title: "Comex",
      cssClass: "aqua",
      hideInMenu: false,
      pageLinks: [
        {
          index: 4,
          subIndex: 0
        }
      ]
    },

    {
      title: "Editorial",
      cssClass: "aqua",
      hideInMenu: false,
      pageLinks: [
        {
          index: 5,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 6,
          subIndex: 0
        }
      ]
    },
    {
      title: "Tallinn women's epee World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 7,
          subIndex: 0
        },
        {
          index: 8,
          subIndex: 0
        },
        {
          index: 9,
          subIndex: 0
        }
      ]
    },
    {
      title: "Bonn men's foil World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 10,
          subIndex: 0
        },
        {
          index: 11,
          subIndex: 0
        },
        {
          index: 12,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 13,
          subIndex: 0
        }
      ]
    },
    {
      title: "Cairo men's sabre World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 14,
          subIndex: 0
        },
        {
          index: 15,
          subIndex: 0
        }
      ]
    },
    {
      title: "Berne men's epee World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 16,
          subIndex: 0
        },
        {
          index: 17,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 18,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 19,
          subIndex: 0
        }
      ]
    },
    {
      title: "Orléans women's sabre World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 20,
          subIndex: 0
        },
        {
          index: 21,
          subIndex: 0
        },
        {
          index: 22,
          subIndex: 0
        }
      ]
    },
    {
      title: "Cairo women's foil World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 23,
          subIndex: 0
        },
        {
          index: 24,
          subIndex: 0
        },
        {
          index: 25,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 26,
          subIndex: 0
        }
      ]
    },
    {
      title: "Saint-Maur women's foil World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 27,
          subIndex: 0
        },
        {
          index: 28,
          subIndex: 0
        },
        {
          index: 29,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 30,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 31,
          subIndex: 0
        }
      ]
    },
    {
      title: "Salt Lake City women's sabre World Cup",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 32,
          subIndex: 0
        },
        {
          index: 33,
          subIndex: 0
        }
      ]
    },
    {
      title: "Tokyo men's foil World Cup and Olympic test event",
      cssClass: "red",
      hideInMenu: false,
      pageLinks: [
        {
          index: 34,
          subIndex: 0
        },
        {
          index: 35,
          subIndex: 0
        },
        {
          index: 36,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 37,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 38,
          subIndex: 0
        }
      ]
    },
    {
      title: "INTERNATIONAL FENCING FEDERATION ANNUAL CONGRESS ",
      cssClass: "gold",
      hideInMenu: false,
      pageLinks: [
        {
          index: 39,
          subIndex: 0
        },
        {
          index: 40,
          subIndex: 0
        },
        {
          index: 41,
          subIndex: 0
        },
        {
          index: 42,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 43,
          subIndex: 0
        }
      ]
    },
    {
      title: "7:1 Rio & Sera Azuma",
      cssClass: "aqua",
      hideInMenu: false,
      pageLinks: [
        {
          index: 44,
          subIndex: 0
        },
        {
          index: 45,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 46,
          subIndex: 0
        }
      ]
    },
    {
      title: "FIE contest seeks new sabre technology",
      cssClass: "green",
      hideInMenu: false,
      pageLinks: [
        {
          index: 47,
          subIndex: 0
        },
        {
          index: 48,
          subIndex: 0
        }
      ]
    },
    {
      title: "Budapest Coaching Academy Open for Enrollment",
      cssClass: "green",
      hideInMenu: false,
      pageLinks: [
        {
          index: 49,
          subIndex: 0
        },
        {
          index: 50,
          subIndex: 0
        },
        {
          index: 51,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 52,
          subIndex: 0
        }
      ]
    },
    {
      title: "Demos and competitions held in Tokyo",
      cssClass: "green",
      hideInMenu: false,
      pageLinks: [
        {
          index: 53,
          subIndex: 0
        },
        {
          index: 54,
          subIndex: 0
        },
        {
          index: 55,
          subIndex: 0
        },
        {
          index: 56,
          subIndex: 0
        }
      ]
    },
    {
      title: "Etropolski European Sabre Cup",
      cssClass: "green",
      hideInMenu: false,
      pageLinks: [
        {
          index: 57,
          subIndex: 0
        },
        {
          index: 58,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 59,
          subIndex: 0
        }
      ]
    },
    {
      title: "Advert",
      cssClass: "advert",
      hideInMenu: true,
      pageLinks: [
        {
          index: 60,
          subIndex: 0
        }
      ]
    },
    {
      title: "Fencing around the world",
      cssClass: "yellow",
      hideInMenu: false,
      pageLinks: [
        {
          index: 61,
          subIndex: 0
        }
      ]
    },
    {
      title: "Obituaries",
      cssClass: "grey",
      hideInMenu: false,
      pageLinks: [
        {
          index: 62,
          subIndex: 0
        }
      ]
    }
  ],
  mobileTemplate: null
};



// WEBPACK FOOTER //
// ./src/document.js